import type { Translations } from './types';

export const fr: Translations = {
  // Common
  'common.loading': 'Chargement…',
  'common.prev': 'Préc.',
  'common.next': 'Suiv.',
  'common.cancel': 'Annuler',
  'common.back': 'Retour',
  'common.search': 'Rechercher',
  'common.close': 'Fermer',
  'common.exit': 'Quitter',
  'common.noData': 'Aucune donnée',
  'common.failedToLoad': 'Échec du chargement',
  'common.retry': 'Réessayer',
  'common.reloadPage': 'Recharger la page',
  'common.beta': 'Bêta',

  // Auth
  'auth.subtitle': 'Plateforme de télémétrie de karting',
  'auth.signInDescription': 'Connectez-vous pour accéder aux données de télémétrie.',
  'auth.signInWithGoogle': 'Se connecter avec Google',
  'auth.signInWithApple': 'Se connecter avec Apple',
  'auth.or': 'ou',
  'auth.signingIn': 'Connexion…',
  'auth.signOut': 'Se déconnecter',

  // OAuth Consent
  'oauth.authorizeTitle': 'Autoriser {name}',
  'oauth.authorizeSubtitle': '{name} souhaite accéder à votre compte de télémétrie kart.win.',
  'oauth.permissionsTitle': 'Autorisations demandées',
  'oauth.permSessions': 'Lire toutes les sessions, les tours et les canaux de télémétrie',
  'oauth.permAnalysis': 'Lire les métriques calculées et les comparaisons',
  'oauth.permSetups': 'Lire les réglages de kart et les configurations de piste',
  'oauth.signedIn': 'Connecté',
  'oauth.mustSignInFirst': 'Veuillez vous connecter pour autoriser cette application',
  'oauth.authorizeButton': "Autoriser l'application",
  'oauth.missingParams': "Paramètres d'autorisation OAuth requis manquants",

  // Settings
  'settings.title': 'Paramètres',
  'settings.account': 'Compte',
  'settings.profile': 'Profil',
  'settings.displayName': "Nom d'affichage",
  'settings.saveName': 'Enregistrer le nom',
  'settings.nameSaved': 'Nom mis à jour avec succès',
  'settings.linkedAccounts': 'Comptes associés',
  'settings.linkGoogle': 'Associer un compte Google',
  'settings.linkApple': 'Associer un compte Apple',
  'settings.unlink': 'Dissocier',
  'settings.linked': 'Associé',
  'settings.notLinked': 'Non associé',
  'settings.cannotUnlinkOnlyProvider': 'Au moins une méthode de connexion doit rester associée.',
  'settings.language': 'Langue',
  'settings.userId': 'ID utilisateur',
  'settings.signOut': 'Se déconnecter',
  'settings.connectedApps': 'Applications connectées',
  'settings.connectedAppsDesc': 'Gérez les assistants IA, IDE et outils autorisés à accéder à vos données de télémétrie via MCP.',
  'settings.noConnectedApps': 'Aucune application connectée pour le moment. Autorisez un client MCP (tel que Claude Desktop ou Cursor) pour le voir apparaître ici.',
  'settings.authorizedOn': 'Autorisé le',
  'settings.lastUsed': 'Dernière utilisation',
  'settings.neverUsed': 'Jamais',
  'settings.revoke': 'Révoquer',
  'settings.revokeAppConfirm': "Voulez-vous vraiment révoquer l'accès de cette application ? Toutes les sessions actives cesseront immédiatement de fonctionner.",
  'settings.appRevokedSuccess': "Accès de l'application révoqué avec succès",
  'settings.copyKey': "Copier l'extrait",
  'settings.keyCopied': 'Copié dans le presse-papiers',
  'settings.mcpConfigSnippet': 'Configuration du client MCP',
  'settings.mcpConfigDesc': "Ajoutez cette configuration dans les paramètres MCP de Claude Desktop (claude_desktop_config.json) ou de Cursor. L'authentification s'effectuera automatiquement via votre navigateur :",
  'settings.deleteAccount': 'Supprimer le compte',
  'settings.deleteAccountDesc': 'Supprimez définitivement votre compte ainsi que toutes les sessions, données de télémétrie, analyses enregistrées, équipements, réglages de kart et partages associés.',
  'settings.deleteAccountConfirmTitle': 'Supprimer définitivement le compte ?',
  'settings.deleteAccountConfirmDesc': 'Cette action est irréversible. Toutes vos sessions, données de télémétrie, analyses enregistrées, équipements, réglages de kart, équipes et partages de sessions seront immédiatement et définitivement supprimés.',
  'settings.deleteAccountConfirmPrompt': 'Pour confirmer, saisissez « {phrase} » dans le champ ci-dessous :',
  'settings.deleteAccountConfirmPhrase': 'supprimer mon compte',
  'settings.deleteAccountConfirmButton': 'Supprimer mon compte',

  // Dashboard
  'dashboard.overview': 'Aperçu',
  'dashboard.subtitle': 'Télémétrie et données de tours',
  'dashboard.recentSessions': 'Sessions récentes',
  'dashboard.total': '{n} au total',
  'dashboard.failedToLoadDashboard': 'Échec du chargement du tableau de bord',
  'dashboard.noDataAvailable': 'Aucune donnée disponible',

  // Stats
  'stats.sessions': 'Sessions',
  'stats.laps': 'Tours',
  'stats.trackTime': 'Temps en piste',
  'stats.tracks': 'Pistes',

  // Search
  'search.placeholder': 'Rechercher des sessions… (p. ex. name:WOHLEN laps:>=5)',
  'search.button': 'Rechercher',
  'search.syntaxHelp': 'Aide sur la syntaxe de recherche',
  'search.title': 'Syntaxe de recherche',
  'search.subtitle': 'Filtrez les sessions à l’aide de paires champ:valeur. Plusieurs termes sont combinés avec ET.',
  'search.closeDialog': 'Fermer la boîte de dialogue',
  'search.operatorsTitle': 'Opérateurs et logique',
  'search.examplesTitle': 'Exemples de requêtes',
  'search.numericComparisons': 'Comparaisons numériques :',
  'search.range': 'Plage :',
  'search.rangeDesc': '— correspond aux valeurs comprises entre 5 et 20 inclus.',
  'search.booleanLogic': 'Logique booléenne :',
  'search.booleanLogicDesc': 'Les termes sont implicitement combinés avec',
  'search.quotes': 'Guillemets :',
  'search.quotesDesc': 'Entourez les valeurs contenant des espaces de guillemets doubles, p. ex.',

  // Filter UI
  'filter.add': 'Ajouter un filtre',
  'filter.allActive': 'Tous les filtres sont actifs',
  'filter.clearAll': 'Tout effacer',
  'filter.clear': 'Effacer',
  'filter.apply': 'Appliquer',
  'filter.cancel': 'Annuler',
  'filter.condition': 'Condition',
  'filter.presets': 'Préréglages',
  'filter.customRange': 'Plage personnalisée',
  'filter.from': 'De',
  'filter.to': 'À',
  'filter.min': 'Min',
  'filter.max': 'Max',
  'filter.value': 'Valeur',
  'filter.searchOptions': 'Rechercher des options...',
  'filter.noOptions': 'Aucune option trouvée',
  'filter.loadingOptions': 'Chargement des options...',

  // Search fields
  'search.field.bareText': '(texte libre)',
  'search.field.bareTextDesc': 'Correspond au nom de la piste ou du pilote contenant ce texte.',
  'search.field.name': 'name',
  'search.field.nameDesc': 'Correspond au nom de la piste ou du pilote contenant la valeur.',
  'search.field.driver': 'driver',
  'search.field.driverDesc': 'Correspond au nom du pilote contenant la valeur.',
  'search.field.laps': 'laps',
  'search.field.lapsDesc': 'Filtre par nombre de tours effectués. Prend en charge =, >, >=, <, <= et les plages.',
  'search.field.temp': 'temp',
  'search.field.tempDesc': 'Filtre par température météo (°C). Prend en charge les opérateurs de comparaison et les plages.',
  'search.field.season': 'season',
  'search.field.seasonDesc': 'Filtre par année de saison (extraite de la date de session). Prend en charge les opérateurs de comparaison.',
  'search.field.from': 'from',
  'search.field.fromDesc': 'Sessions à partir d’une date donnée. Accepte YYYY-MM-DD ou une valeur relative : -7d, -2w, -3m, -1y.',
  'search.field.to': 'to',
  'search.field.toDesc': 'Sessions jusqu’à une date donnée. Mêmes formats que « from ».',

  // Search examples
  'search.example.wohlenLaps': 'Sessions à Wohlen avec 5+ tours',
  'search.example.yanick30d': 'Sessions de Yanick des 30 derniers jours',
  'search.example.tempLaps': 'Sessions entre 15 et 25 °C avec 3+ tours',
  'search.example.wohlenMagny': 'Sessions à Wohlen ou Magny de la dernière année',

  // Session list
  'sessionList.date': 'Date',
  'sessionList.time': 'Heure',
  'sessionList.track': 'Piste',
  'sessionList.sessions': 'Sessions',
  'sessionList.driver': 'Pilote',
  'sessionList.laps': 'Tours',
  'sessionList.best': 'Meilleur',
  'sessionList.weather': 'Météo',
  'sessionList.lapsUnit': '{n} tours',
  'sessionList.sessionCount': '{count} sessions',
  'sessionList.sessionCountSingular': '1 session',
  'sessionList.noSessions': 'Aucune session trouvée. Essayez une autre recherche.',

  // Track bests
  'trackBests.title': 'Records de piste',

  // Session detail
  'session.title': 'Session',
  'session.failedToLoad': 'Échec du chargement de la session',
  'session.noData': 'Aucune donnée de session',
  'session.chipOverview': 'Aperçu',
  'session.chipDiff': 'Écart',
  'session.tabWeather': 'Météo',
  'session.tabLaps': 'Tours',
  'session.tabSetup': 'Réglages',
  'session.tabManage': 'Gérer',
  'session.dangerZone': 'Zone de danger',
  'session.deleteDescription': 'Supprimez définitivement cette session, tous les tours enregistrés et les données de télémétrie. Cette action est irréversible.',
  'session.delete': 'Supprimer la session',
  'session.deleteConfirmTitle': 'Supprimer la session',
  'session.deleteConfirmMessage': 'Voulez-vous vraiment supprimer cette session ? Cette action est irréversible et supprimera définitivement toutes les données de tours et de télémétrie.',
  'session.deleteSuccess': 'Session supprimée avec succès',
  'session.deleteFailed': 'Échec de la suppression de la session',
  'session.deleting': 'Suppression de la session...',

  // Session meta
  'sessionMeta.date': 'Date',
  'sessionMeta.driver': 'Pilote',
  'sessionMeta.track': 'Piste',
  'sessionMeta.laps': 'Tours',
  'sessionMeta.device': 'Appareil',
  'sessionMeta.status': 'Statut',
  'sessionMeta.tyres': 'Pneus',
  'sessionMeta.tyreAge': '{n} tours',
  'sessionMeta.fresh': 'Neufs',

  // Weather
  'weather.wind': 'Vent',
  'weather.humidity': 'Humidité',
  'weather.cloudCover': 'Couverture nuageuse',
  'weather.precipitation': 'Précipitations',
  'weather.pressure': 'Pression',
  'weather.feels': 'Ressenti',
  'weather.clear': 'Dégagé',
  'weather.partlyCloudy': 'Partiellement nuageux',
  'weather.overcast': 'Couvert',
  'weather.fog': 'Brouillard',
  'weather.drizzle': 'Bruine',
  'weather.rain': 'Pluie',
  'weather.freezingRain': 'Pluie verglaçante',
  'weather.snow': 'Neige',
  'weather.rainShowers': 'Averses de pluie',
  'weather.snowShowers': 'Averses de neige',
  'weather.thunderstorm': 'Orage',
  'weather.unknown': 'Inconnu',

  // Lap table
  'lapTable.title': 'Temps au tour',
  'lapTable.theoLap': 'Meilleur tour',
  'lapTable.aggregation': 'Agrégation',
  'lapTable.compare': 'Comparer',
  'lapTable.lapTime': 'Temps au tour',
  'lapTable.delta': 'Delta',
  'lapTable.maxRpm': 'RPM max',
  'lapTable.minRpm': 'RPM min',
  'lapTable.maxSpeed': 'Vitesse max',
  'lapTable.minSpeed': 'Vitesse min',
  'lapTable.tyreAge': 'Usure pneus',

  // Diff chart
  'diffChart.outlierLap': 'Non pertinent',
  'diffChart.deltaToBest': 'Delta / meilleur',

  // Lap analysis
  'lapAnalysis.title': 'Analyse du tour {n}',
  'lapAnalysis.resetZoom': 'Réinitialiser le zoom',
  'lapAnalysis.speed': 'Vitesse',
  'lapAnalysis.acceleration': 'Accélération',
  'lapAnalysis.rpm': 'RPM',
  'lapAnalysis.gForce': 'Force G',
  'lapAnalysis.trackMap': 'Carte de la piste',
  'lapAnalysis.failedToLoad': 'Échec du chargement de la télémétrie',
  'lapAnalysis.noTelemetry': 'Aucune donnée de télémétrie pour ce tour.',

  // Lap info
  'lapInfo.lapTime': 'Temps au tour',
  'lapInfo.maxRpm': 'RPM max',
  'lapInfo.minRpm': 'RPM min',
  'lapInfo.maxSpeed': 'Vitesse max',
  'lapInfo.maxTemp': 'Temp. max',
  'lapInfo.gpsOffset': 'Décalage GPS',
  'lapInfo.gpsOffsetTooltip': 'Dérive GPS corrigée : {east} E, {north} N',

  // Navigation
  'nav.data': 'Données',
  'nav.home': 'Sessions',
  'nav.tools': 'Outils',
  'nav.compare': 'Comparer',
  'nav.drivers': 'Pilotes',
  'nav.tracks': 'Pistes',
  'nav.settings': 'Paramètres',

  // Analysis
  'analysis.title': "Outils d'analyse",
  'analysis.subtitle': "Explorez vos données de télémétrie en profondeur grâce à des outils d'analyse spécialisés.",
  'analysis.sector.title': 'Analyse par secteur',
  'analysis.sector.desc': 'Comparez les secteurs de tour sur plusieurs sessions pour déterminer les meilleurs tours théoriques et analyser la régularité.',


  // Braking Analysis
  'analysis.braking.title': 'Analyse du freinage',
  'analysis.braking.desc': "Analysez les points de freinage, les zones de décélération, les cercles d'adhérence G-G et l'efficacité du freinage dégressif.",
  'braking.title': 'Analyse du freinage',
  'braking.desc': "Analysez les points de freinage, les zones de décélération, les cercles d'adhérence G-G et l'efficacité du freinage dégressif.",
  'braking.wizardChooseTrack': 'Choisir la piste',
  'braking.wizardSelect': 'Sélectionner les sessions',
  'braking.wizardResults': 'Résultats',
  'braking.noTracksWithCorners': 'Aucune piste avec tracé et virages configurés disponible.',
  'braking.noSessionsForTrack': 'Aucune session trouvée pour la piste',
  'braking.noBrakingZones': 'Aucune zone de freinage détectée pour cette piste.',
  'braking.selectZone': 'Sélectionner une zone de freinage',
  'braking.zone': 'Zone de freinage',
  'braking.zones': 'Zones de freinage',
  'braking.brakePoint': 'Point de freinage',
  'braking.apex': 'Point de corde',
  'braking.exit': 'Sortie',
  'braking.distance': 'Distance de freinage',
  'braking.duration': 'Durée de freinage',
  'braking.initialSpeed': 'Vitesse initiale',
  'braking.apexSpeed': 'Vitesse min',
  'braking.minSpeed': 'Vitesse min',
  'braking.brakeRelease': 'Relâchement des freins',
  'braking.exitSpeed': 'Vitesse de sortie',
  'braking.speedDrop': 'Perte de vitesse',
  'braking.peakDecel': 'Décélération max',
  'braking.peakLateral': 'Adhérence latérale max',
  'braking.trailScore': 'Score de freinage dégressif',
  'braking.trailScoreDesc': "Mesure de l'utilisation du cercle d'adhérence lors de la transition entre le freinage longitudinal et l'appui latéral en virage.",
  'braking.scoreOptimal': 'Optimal',
  'braking.scoreGood': 'Bon',
  'braking.scoreNeedsWork': 'À travailler',
  'braking.sessionMedian': 'Médiane de la session',
  'braking.selectedLap': 'Tour sélectionné',
  'braking.speedTransition': 'Transition de vitesse',
  'braking.decelAndGrip': 'Décélération et adhérence',
  'braking.trailScoreAdviceOptimal': "Excellent dosage dégressif des freins en entrée de virage. Forte utilisation du cercle d'adhérence.",
  'braking.trailScoreAdviceGood': "Transition fluide. Possibilité de prolonger légèrement le freinage dégressif plus loin en entrée de virage.",
  'braking.trailScoreAdviceNeedsWork': "Relâchement brusque des freins avant le braquage. Concentrez-vous sur un relâchement progressif tout en inscrivant le kart.",
  'braking.overallHeader': 'Performance globale au freinage',
  'braking.overallHeaderDesc': 'Efficacité du freinage dégressif sur toute la piste et régularité par virage sur l’ensemble des tours et sessions sélectionnés.',
  'braking.perCornerHeader': 'Analyse par virage',
  'braking.perCornerHeaderDesc': "Cinématique détaillée, cercle d'adhérence G-G et courbes de télémétrie pour la zone de freinage sélectionnée.",
  'braking.overallScore': 'Score global de freinage dégressif',
  'braking.overallScoreDesc': "Utilisation moyenne du cercle d'adhérence sur tous les virages et tous les tours",
  'braking.mostConsistentCorner': 'Virage le plus régulier',
  'braking.leastConsistentCorner': 'Virage le moins régulier',
  'braking.consistency': 'Régularité',
  'braking.lapTimeline': 'Évolution du score tour par tour',
  'braking.sessionComparison': 'Comparaison des sessions',
  'braking.selectCornerHint': 'Cliquez pour inspecter le virage',
  'braking.stdDevLabel': 'Écart-type',
  'braking.ggDiagram': 'Diagramme G-G',
  'braking.frictionCircle': "Cercle d'adhérence",
  'braking.telemetryChart': 'Télémétrie de freinage',
  'braking.speed': 'Vitesse',
  'braking.gLong': 'G longitudinal',
  'braking.gLat': 'G latéral',
  'braking.gTotal': 'G combiné',
  'braking.allLaps': 'tours',
  'braking.compareLap': 'Comparer',
  'braking.comparisonLap': 'Comparaison',
  'braking.clearComparison': 'Effacer la comparaison',
  'braking.lapTime': 'Temps au tour',
  'braking.driver': 'Pilote',
  'braking.lap': 'Tour',
  'braking.lapSpeedTable': 'Détail des tours au freinage',
  'braking.lapsAnalyzed': 'tours analysés',
  'braking.legendDecel': 'Décél. en ligne droite',
  'braking.legendTrail': 'Freinage dégressif',
  'braking.legendApex': 'Point de corde',
  'braking.legendExit': 'Réaccélération',

  // Corner Speed Analysis
  'analysis.corner.title': 'Analyse de vitesse en virage',
  'analysis.corner.desc': 'Mesurez et comparez les vitesses d’entrée, de point de corde et de sortie de virage entre les tours et les sessions.',
  'corner.title': 'Analyse de vitesse en virage',
  'corner.wizardChooseTrack': 'Choisir la piste',
  'corner.wizardSelect': 'Sélectionner les sessions',
  'corner.wizardResults': 'Résultats',
  'corner.entrance': 'Entrée',
  'corner.apex': 'Point de corde',
  'corner.exit': 'Sortie',
  'corner.entranceSpeed': "Vitesse d'entrée",
  'corner.apexSpeed': 'Vitesse au point de corde',
  'corner.exitSpeed': 'Vitesse de sortie',
  'corner.speedGain': 'Gain de vitesse',
  'corner.turn': 'Virage',
  'corner.leftTurn': 'Virage à gauche',
  'corner.rightTurn': 'Virage à droite',
  'corner.avgSpeed': 'Vitesse moyenne',
  'corner.maxSpeed': 'Vitesse max',
  'corner.minSpeed': 'Vitesse min',
  'corner.fastest': 'Plus rapide',
  'corner.slowest': 'Plus lent',
  'corner.spread': 'Écart',
  'corner.deltaToBest': 'Δ / meilleur',
  'corner.deltaToAvg': 'Δ / moy.',
  'corner.allCornersOverview': 'Aperçu de tous les virages',
  'corner.aggregatedData': 'Statistiques de vitesse agrégées',
  'corner.lapSpeedTable': 'Détail des vitesses par tour',
  'corner.lapsAnalyzed': 'tours analysés',
  'corner.noTracksWithCorners': 'Aucune piste avec tracé et virages configurés disponible.',
  'corner.noSessionsForTrack': 'Aucune session trouvée pour la piste',
  'corner.noCornersFound': 'Aucune annotation de virage trouvée pour cette piste.',
  'corner.selectCorner': 'Sélectionner un virage',
  'corner.rank': 'Rang',
  'corner.driver': 'Pilote',
  'corner.lap': 'Tour',
  'corner.lapTime': 'Temps au tour',
  'corner.session': 'Session',
  'corner.speed': 'Vitesse',
  'corner.avgMax': 'Moy. / Max',
  'corner.activeMetric': 'Métrique active :',
  'corner.metricSpeed': 'Vitesse',
  'corner.metricRpm': 'RPM',
  'corner.metricDuration': 'Durée',
  'corner.entranceRpm': "RPM d'entrée",
  'corner.apexRpm': 'RPM au point de corde',
  'corner.exitRpm': 'RPM de sortie',
  'corner.rpmGain': 'Gain de RPM',
  'corner.rpm': 'RPM',
  'corner.duration': 'Durée',
  'corner.transitDuration': 'Durée de passage en virage',
  'corner.bestDuration': 'Meilleure durée',
  'corner.avgDuration': 'Durée moy.',
  'corner.worstDuration': 'Durée la plus lente',
  'corner.deltaToBestDuration': 'Δ / meilleur',
  'corner.fullTransit': 'Passage complet',



  // Sector analysis
  'sector.wizardChooseTrack': 'Choisir la piste',
  'sector.wizardDefine': 'Définir les secteurs',
  'sector.wizardSelect': 'Sélectionner les sessions',
  'sector.wizardResults': 'Résultats',
  'sector.title': 'Analyse par secteur',
  'sector.defineSectors': 'Définir les secteurs',
  'sector.clickToAdd': 'Cliquer pour ajouter · Glisser pour déplacer (max. 3 secteurs)',
  'sector.selectSessions': 'Sélectionner les sessions →',
  'sector.analyzingLap': '⏳ Analyse du tour…',
  'sector.analyzeLap': '⚡ Analyser le tour',
  'sector.noResults': 'Aucun résultat disponible',
  'sector.noResultsHint': 'Revenez en arrière et ajustez vos secteurs ou vos sessions',
  'sector.trackSectors': 'Secteurs de la piste',
  'sector.sectorN': 'Secteur {n}',
  'sector.noSessionsForTrack': 'Aucune session trouvée pour la piste',
  'sector.failedToLoad': "Échec du chargement de l'analyse par secteur",
  'sector.lapStats': 'Statistiques des tours',
  'sector.lapStatsDriver': 'Pilote',
  'sector.lapStatsTotal': 'Total',

  // Sector panel
  'sectorPanel.time': 'Temps',
  'sectorPanel.topSpeed': 'Vitesse de pointe',
  'sectorPanel.minSpeed': 'Vitesse min',
  'sectorPanel.maxRpm': 'RPM max',
  'sectorPanel.minRpm': 'RPM min',
  'sectorPanel.duration': 'Durée',
  'sectorPanel.best': 'Meilleur',
  'sectorPanel.avg': 'Moy.',
  'sectorPanel.median': 'Médiane',
  'sectorPanel.worst': 'Moins bon',
  'sectorPanel.p10': 'P10',
  'sectorPanel.p5': 'P5',
  'sectorPanel.consistency': 'Régularité',
  'sectorPanel.lapByLap': 'Évolution tour par tour',
  'sectorPanel.sessionMedians': 'Médianes par session',
  'sectorPanel.medianTopSpeed': 'Vitesse de pointe médiane',
  'sectorPanel.medianMinSpeed': 'Vitesse min médiane',
  'sectorPanel.medianMaxRpm': 'RPM max médian',
  'sectorPanel.medianMinRpm': 'RPM min médian',
  'sectorPanel.medianTime': 'Temps médian',
  'sectorPanel.session': 'Session',
  'sectorPanel.lap': 'Tour',
  'sectorPanel.maxSpeed': 'Vitesse max',

  // Split points
  'splitPoints.clearAll': 'Tout effacer',

  // Session selector
  'sessionSelector.allDrivers': 'Tous les pilotes',
  'sessionSelector.allWeather': 'Toutes les météos',
  'sessionSelector.dryOnly': '☀️ Sec uniquement',
  'sessionSelector.wetOnly': '🌧️ Pluie uniquement',
  'sessionSelector.selectAll': 'Tout sélectionner',
  'sessionSelector.deselectAll': 'Tout désélectionner',

  // Theoretical best
  'theoBest.title': 'Meilleur tour théorique',
  'theoBest.type': 'Type',
  'theoBest.time': 'Temps',
  'theoBest.delta': 'Delta',
  'theoBest.theoretical': 'Théorique',
  'theoBest.actualBest': 'Meilleur réel',

  // Lap selector
  'lapSelector.title': 'Sélectionner des tours',
  'lapSelector.loadingLaps': 'Chargement des tours…',
  'lapSelector.noLaps': 'Aucun tour',
  'lapSelector.best': 'MEILLEUR',

  // Navigation – races
  'nav.races': 'Courses',

  // Tracks
  'tracks.title': 'Pistes',
  'tracks.subtitle': 'Toutes les pistes et classements',
  'tracks.noData': 'Aucune piste disponible',
  'tracks.failedToLoad': 'Échec du chargement des pistes',
  'tracks.sessions': '{n} sessions',
  'tracks.raceSessions': '{n} sessions de course',
  'tracks.bestLap': 'Meilleur tour',
  'tracks.rank': '#',
  'tracks.lapTime': 'Temps au tour',
  'tracks.driver': 'Pilote',
  'tracks.date': 'Date',
  'tracks.sectors': 'Secteurs',
  'tracks.weather': 'Météo',
  'tracks.measuredLapsTab': 'Tours mesurés',
  'tracks.raceTab': 'Courses',
  'tracks.leaderboard': 'Classement',
  'tracks.category': 'Catégorie',
  'tracks.season': 'Saison',
  'tracks.position': 'Pos.',
  'tracks.sessionType': 'Type',
  'tracks.sourceCanonical': 'Piste',
  'tracks.sourceSession': 'Session uniquement',
  'tracks.sourceRaceEvent': 'Course uniquement',
  'tracks.searchPlaceholder': 'Rechercher des pistes…',
  'tracks.source': 'Source',
  'tracks.searchHelp.title': 'Syntaxe de recherche des pistes',
  'tracks.searchHelp.subtitle': 'Recherchez par nom de piste. La recherche est insensible à la casse et aux accents.',
  'tracks.searchHelp.nameField': '(texte)',
  'tracks.searchHelp.nameDesc': 'Correspond aux pistes dont le nom contient le texte indiqué. Les caractères accentués sont reconnus avec ou sans accent (p. ex. « Geneve » correspond à « Genève »).',
  'tracks.searchHelp.example1': 'Wohlen',
  'tracks.searchHelp.example1Desc': 'Toutes les pistes contenant « Wohlen »',
  'tracks.searchHelp.example2': 'franciacorta',
  'tracks.searchHelp.example2Desc': 'Recherche insensible à la casse pour « Franciacorta »',
  'tracks.searchHelp.example3': 'Sarno',
  'tracks.searchHelp.example3Desc': 'Toutes les pistes contenant « Sarno »',

  // Track detail tabs
  'tracks.layoutTab': 'Tracé',
  'tracks.noTrackLayout': 'Aucun tracé de piste disponible',
  'tracks.officialLapsTab': 'Tours officiels',
  'tracks.noRaceEvents': 'Aucun événement de course trouvé',
  'tracks.round': 'Manche',
  'tracks.championship': 'Championnat',
  'tracks.dateStart': 'Date',
  'tracks.country': 'Pays',
  'tracks.sessionsCount': 'Sessions',
  'tracks.driversCount': 'Pilotes',
  // Track race events search
  'tracks.raceEvents.searchPlaceholder': 'Rechercher des événements de course…',
  'tracks.raceEvents.searchHelp.title': "Recherche d'événements de course",
  'tracks.raceEvents.searchHelp.subtitle': 'Filtrez les événements de course par saison ou par nom de championnat',
  'tracks.raceEvents.searchHelp.seasonField': 'season:<année>',
  'tracks.raceEvents.searchHelp.seasonDesc': 'Filtrer par année de saison (correspondance exacte)',
  'tracks.raceEvents.searchHelp.championshipField': 'championship:<nom>',
  'tracks.raceEvents.searchHelp.championshipDesc': 'Filtrer par nom de championnat (insensible à la casse)',
  'tracks.raceEvents.searchHelp.example1': 'season:2026',
  'tracks.raceEvents.searchHelp.example1Desc': 'Tous les événements de la saison 2026',
  'tracks.raceEvents.searchHelp.example2': 'championship:RMC',
  'tracks.raceEvents.searchHelp.example2Desc': 'Tous les événements des championnats contenant « RMC »',

  // Track leaderboard search
  'tracks.leaderboard.searchPlaceholder': 'Rechercher des tours...',
  'tracks.leaderboard.searchHelp.title': 'Recherche dans le classement',
  'tracks.leaderboard.searchHelp.subtitle': 'Utilisez des filtres pour affiner les résultats',
  'tracks.leaderboard.searchHelp.driverField': 'driver:<nom>',
  'tracks.leaderboard.searchHelp.driverDesc': 'Filtrer par nom de pilote (insensible à la casse)',
  'tracks.leaderboard.searchHelp.seasonField': 'season:<année>',
  'tracks.leaderboard.searchHelp.seasonDesc': 'Filtrer par année de saison',
  'tracks.leaderboard.searchHelp.categoryField': 'category:<nom>',
  'tracks.leaderboard.searchHelp.categoryDesc': 'Filtrer par catégorie (p. ex. DD2, Junior)',
  'tracks.leaderboard.searchHelp.typeField': 'type:<typeSession>',
  'tracks.leaderboard.searchHelp.typeDesc': 'Filtrer par type de course (qualifying, heat-1, final...)',
  'tracks.leaderboard.searchHelp.posField': 'pos<:<N>',
  'tracks.leaderboard.searchHelp.posDesc': "Position d'arrivée maximale (p. ex. pos<:3 = podium)",
  'tracks.leaderboard.searchHelp.tempMinField': 'temp>:<N>',
  'tracks.leaderboard.searchHelp.tempMinDesc': 'Température minimale en °C',
  'tracks.leaderboard.searchHelp.tempMaxField': 'temp<:<N>',
  'tracks.leaderboard.searchHelp.tempMaxDesc': 'Température maximale en °C',
  'tracks.leaderboard.searchHelp.fromField': 'from:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.fromDesc': 'Filtre de date de début',
  'tracks.leaderboard.searchHelp.toField': 'to:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.toDesc': 'Filtre de date de fin',
  'tracks.leaderboard.searchHelp.example1': 'driver:gubser season:2026',
  'tracks.leaderboard.searchHelp.example1Desc': 'Trouver un pilote dans la saison 2026',
  'tracks.leaderboard.searchHelp.example2': 'category:dd2 type:final',
  'tracks.leaderboard.searchHelp.example2Desc': 'Finales DD2 uniquement',
  'tracks.leaderboard.searchHelp.example3': 'pos<:3 from:2026-01-01',
  'tracks.leaderboard.searchHelp.example3Desc': 'Podiums en 2026',

  // Drivers
  'drivers.title': 'Pilotes',
  'drivers.driver': 'Pilote',
  'drivers.events': 'Événements',
  'drivers.noData': 'Aucun pilote trouvé',
  'drivers.failedToLoad': 'Échec du chargement des pilotes',
  'drivers.searchPlaceholder': 'Rechercher par nom…',

  // Races
  'races.title': 'Résultats de course',
  'races.seasons': 'Saisons',
  'races.events': '{n} événements',
  'races.categories': '{n} catégories',
  'races.round': 'Manche {n}',
  'races.allCategories': 'Toutes les catégories',
  'races.noEvents': 'Aucun événement trouvé',
  'races.failedToLoad': 'Échec du chargement des données de course',
  'races.noData': 'Aucune donnée de course disponible',
  'races.position': 'Pos',
  'races.kart': '#',
  'races.driver': 'Pilote',
  'races.bestLap': 'Meilleur tour',
  'races.totalTime': 'Temps total',
  'races.gap': 'Écart',
  'races.status': 'Statut',
  'races.grid': 'Grille',
  'races.lap': 'Tour',
  'races.laps': 'Tours',
  'races.penalty': 'Pénalité',
  'races.lapProgression': 'Progression par tour',
  'races.results': 'Résultats',
  'races.driverHistory': 'Historique du pilote',
  'races.raceStarts': 'Départs',
  'races.podiums': 'Podiums',
  'races.dnfDsq': 'DNF / DSQ',
  'races.qualiPoles': 'Poles aux qualifs',
  'races.track': 'Piste',
  'races.session': 'Session',
  'races.year': 'Année',
  'races.category': 'Catégorie',
  'races.pole': 'Pole',
  'races.winner': 'Vainqueur',
  'races.finish': 'Arrivée',
  'races.sessionType.qualifying': 'Qualifications',
  'races.sessionType.heat-1': 'Manche 1',
  'races.sessionType.heat-2': 'Manche 2',
  'races.sessionType.heat-3': 'Manche 3',
  'races.sessionType.heat-ab': 'Manche A-B',
  'races.sessionType.heat-bc': 'Manche B-C',
  'races.sessionType.heat-ac': 'Manche A-C',
  'races.sessionType.final': 'Finale',

  // Race overview
  'races.overview': 'Aperçu',

  // Driver race search
  'races.searchPlaceholder': 'Rechercher des courses… p. ex. Castelletto ou type:race',
  'races.querySyntaxHelp': 'Aide sur la syntaxe de recherche',
  'races.sessionCount': '{count} sessions',
  'races.sessionCountSingular': '1 session',
  'races.eventsFound': '{n} événement(s) trouvé(s)',

  // Session detail tabs (below results table)
  'races.sessionTabWeather': 'Météo',
  'races.sessionTabPace': 'Rythme',
  'common.comingSoon': 'Bientôt disponible',

  // Driver pace
  'races.tabRaces': 'Courses',
  'races.tabStats': 'Statistiques',
  'races.tabPace': 'Rythme',
  'races.paceDescription': 'Meilleur temps au tour par phase',
  'races.paceNoData': 'Aucune donnée de rythme disponible pour cette catégorie.',
  'races.paceEvents': '{n} événements',
  'races.paceQualifying': 'Meilleur temps au tour sur tous les événements',

  // Driver stats
  'races.statWins': 'Victoires',
  'races.statAvgFinish': "Position d'arrivée moy.",
  'races.statSeasons': 'Saisons',
  'races.statTracks': 'Pistes',
  'races.statCategories': 'Catégories',
  'races.statTotalLaps': 'Total de tours',

  'driverSearchHelp.title': 'Syntaxe de recherche des courses',
  'driverSearchHelp.subtitle': 'Filtrez les résultats de course à l’aide de paires champ:valeur. Plusieurs termes sont combinés avec ET.',
  'driverSearchHelp.bareText': '(texte libre)',
  'driverSearchHelp.bareTextDesc': 'Correspond au nom de la piste ou du championnat contenant ce texte.',
  'driverSearchHelp.track': 'track',
  'driverSearchHelp.trackDesc': 'Correspond au nom de la piste contenant la valeur.',
  'driverSearchHelp.championship': 'championship',
  'driverSearchHelp.championshipDesc': 'Correspond au nom du championnat contenant la valeur.',
  'driverSearchHelp.category': 'category',
  'driverSearchHelp.categoryDesc': 'Correspond au nom de la catégorie contenant la valeur.',
  'driverSearchHelp.type': 'type',
  'driverSearchHelp.typeDesc': 'Correspond au type ou au libellé de la session (p. ex. race, qualifying, heat).',
  'driverSearchHelp.position': 'position',
  'driverSearchHelp.positionDesc': "Filtre par position d'arrivée. Prend en charge =, >, >=, <, <= et les plages.",
  'driverSearchHelp.laps': 'laps',
  'driverSearchHelp.lapsDesc': 'Filtre par tours effectués. Prend en charge les opérateurs de comparaison et les plages.',
  'driverSearchHelp.season': 'season',
  'driverSearchHelp.seasonDesc': 'Filtre par année de saison du championnat. Prend en charge les opérateurs de comparaison.',
  'driverSearchHelp.from': 'from',
  'driverSearchHelp.fromDesc': 'Courses à partir d’une date donnée. Accepte YYYY-MM-DD ou une valeur relative : -7d, -2w, -3m, -1y.',
  'driverSearchHelp.to': 'to',
  'driverSearchHelp.toDesc': 'Courses jusqu’à une date donnée. Mêmes formats que « from ».',
  'driverSearchHelp.operatorsTitle': 'Opérateurs et logique',
  'driverSearchHelp.numericComparisons': 'Comparaisons numériques :',
  'driverSearchHelp.range': 'Plage :',
  'driverSearchHelp.rangeDesc': '— correspond aux valeurs comprises entre 5 et 20 inclus.',
  'driverSearchHelp.booleanLogic': 'Logique booléenne :',
  'driverSearchHelp.booleanLogicDesc': 'Les termes sont implicitement combinés avec',
  'driverSearchHelp.quotes': 'Guillemets :',
  'driverSearchHelp.quotesDesc': 'Entourez les valeurs contenant des espaces de guillemets doubles, p. ex.',
  'driverSearchHelp.examplesTitle': 'Exemples de requêtes',
  'driverSearchHelp.example1Desc': 'Résultats de course à Castelletto',
  'driverSearchHelp.example2Desc': 'Podiums du championnat RMC de la dernière année',
  'driverSearchHelp.example3Desc': 'Résultats en finale dans le top 3',

  // Drivers List Search Help
  'driversListSearchHelp.title': 'Recherche de pilotes',
  'driversListSearchHelp.subtitle': 'Rechercher des pilotes par nom',
  'driversListSearchHelp.bareText': 'Mots-clés',
  'driversListSearchHelp.bareTextDesc': 'Les mots-clés sont comparés au prénom et au nom de famille. Plusieurs mots-clés sont traités comme des conditions ET.',
  'driversListSearchHelp.from': 'from',
  'driversListSearchHelp.fromDesc': 'Pilotes actifs à partir d’une date donnée. Accepte YYYY-MM-DD ou une valeur relative : -7d, -2w, -3m, -1y.',
  'driversListSearchHelp.to': 'to',
  'driversListSearchHelp.toDesc': 'Pilotes actifs jusqu’à une date donnée. Mêmes formats que « from ».',
  'driversListSearchHelp.season': 'season',
  'driversListSearchHelp.seasonDesc': 'Pilotes actifs lors d’une saison de championnat spécifique. Prend en charge les opérateurs de comparaison comme season:>2020.',
  'driversListSearchHelp.category': 'category',
  'driversListSearchHelp.categoryDesc': 'Pilotes actifs dans une catégorie spécifique (p. ex. Rotax Max).',
  'driversListSearchHelp.example.yanick': 'Trouver les pilotes prénommés Yanick',
  'driversListSearchHelp.example.senn': 'Trouver les pilotes nommés Senn',
  'driversListSearchHelp.example.from': 'Pilotes actifs depuis 2026',
  'driversListSearchHelp.example.season': 'Pilotes actifs en 2025 ou plus récent',
  'driversListSearchHelp.example.category': 'Pilotes actifs en Rotax Max',
  'drivers.lastAppearance': 'Dernière apparition',

  // Tyre Analysis
  'analysis.tyre.title': 'Analyse des pneus',
  'analysis.tyre.desc': "Analysez l'historique des pneus et estimez des temps au tour réalistes selon les conditions actuelles.",
  'tyre.selectTitle': 'Sélectionner un train de pneus',
  'tyre.selectHint': 'Affichage de vos trains de pneus utilisés le plus récemment. Vous pouvez également scanner un code-barres.',
  'tyre.scanBarcode': 'Scanner',
  'tyre.barcodeSearch': 'Rechercher par code-barres ou par nom...',
  'tyre.fastestLaps': 'Meilleurs tours par piste',
  'tyre.expectations': 'Estimations réalistes',
  'tyre.totalLaps': 'Total de tours parcourus',
  'tyre.totalSessions': 'Sessions',
  'tyre.longestSession': 'Plus longue session',
  'tyre.ageLaps': '{n} tours',
  'tyre.noData': 'Aucune donnée',
  'tyre.expectedMedian': 'Attendu',
  'tyre.matchingLaps': 'Tours correspondants',
  'tyre.noTyresFound': 'Aucun train de pneus trouvé.',
  'tyre.noFastestLaps': 'Aucun tour enregistré avec ce train de pneus pour le moment.',
  'tyre.noExpectations': 'Aucune piste avec données GPS disponible pour les prédictions.',
  'tyre.dry': 'Sec',
  'tyre.wet': 'Pluie',
  'tyre.pointCamera': 'Pointez votre caméra vers un code-barres',
  'tyre.wizardSelect': 'Sélectionner un pneu',
  'tyre.wizardResults': 'Résultats',
  'tyre.back': 'Retour',
  'tyre.exit': 'Quitter',
  'tyre.trackColumn': 'Piste',
  'tyre.bestLapColumn': 'Meilleur tour',
  'tyre.dateColumn': 'Date',
  'tyre.ageColumn': 'Usure',
  'tyre.weatherColumn': 'Météo',
  'tyre.tempColumn': 'Temp.',
  'tyre.expected': 'Attendu :',

  // Tyre Overview
  'analysis.tyreOverview.title': 'Aperçu des pneus',
  'tyreOverview.summaryTotal': 'Total',
  'tyreOverview.summaryFresh': 'Neufs',
  'tyreOverview.summaryWorn': 'Usés',
  'tyreOverview.summaryEndOfLife': 'Fin de vie',
  'tyreOverview.endOfLife': '⚠ Fin de vie',
  'tyreOverview.scanButton': 'Scanner',
  'tyreOverview.noTyres': 'Aucun pneu actif trouvé.',
  'tyreOverview.scanNotFound': 'Aucun pneu trouvé pour le code-barres scanné.',
  'tyreOverview.laps': 'tours',
  'tyreOverview.colTyre': 'Pneu',
  'tyreOverview.colCompound': 'Gomme',
  'tyreOverview.colLaps': 'Tours',
  'tyreOverview.colLastUsed': 'Dernière utilisation',
  'tyreOverview.colStatus': 'Statut',
  'tyreOverview.discardButton': 'Marquer comme mis au rebut',
  'tyreOverview.discardAction': 'Mettre au rebut',
  'tyreOverview.discardSuccess': 'Train de pneus marqué comme mis au rebut.',
  'tyreOverview.searchPlaceholder': 'Rechercher des pneus (p. ex. brand:Mojo compound:dry laps:<50)...',
  'tyreOverview.searchHelp.title': "Recherche dans l'aperçu des pneus",
  'tyreOverview.searchHelp.subtitle': 'Filtrez et trouvez des trains de pneus actifs par marque, gomme, nombre de tours, code-barres ou piste.',
  'tyreOverview.searchHelp.bareText': 'Texte',
  'tyreOverview.searchHelp.bareTextDesc': 'Correspond à la marque, au modèle, au numéro de référence, au code-barres ou à la dernière piste utilisée.',
  'tyreOverview.searchHelp.brandDesc': 'Filtrer par fabricant ou marque de pneu (p. ex. Mojo, Vega).',
  'tyreOverview.searchHelp.typeDesc': 'Filtrer par modèle ou type de pneu (p. ex. D2, White).',
  'tyreOverview.searchHelp.nrDesc': 'Filtrer par numéro de référence du train de pneus.',
  'tyreOverview.searchHelp.compoundDesc': 'Filtrer par type de gomme (« dry » ou « wet »).',
  'tyreOverview.searchHelp.lapsDesc': 'Filtrer par nombre cumulé de tours parcourus avec des opérateurs de comparaison (=, >, <, >=, <=) ou des plages (p. ex. 0..20).',
  'tyreOverview.searchHelp.barcodeDesc': 'Filtrer par code-barres ou numéro de série individuel du pneu.',
  'tyreOverview.searchHelp.trackDesc': 'Filtrer par nom de la piste où le train de pneus a été utilisé pour la dernière fois.',
  'tyreOverview.searchHelp.fromDesc': 'Correspond aux pneus utilisés pour la dernière fois à partir de cette date (YYYY-MM-DD ou relative comme -30d).',
  'tyreOverview.searchHelp.toDesc': 'Correspond aux pneus utilisés pour la dernière fois jusqu’à cette date (YYYY-MM-DD ou relative comme -1m).',
  'tyreOverview.searchHelp.example.mojoDry': 'Pneus gomme sèche de marque Mojo',
  'tyreOverview.searchHelp.example.lapsEol': 'Pneus ayant atteint leur fin de vie (70+ tours)',
  'tyreOverview.searchHelp.example.lapsRange': 'Pneus neufs ou peu usés ayant entre 0 et 20 tours',
  'tyreOverview.searchHelp.example.trackFrom': 'Pneus utilisés pour la dernière fois à Lonato depuis le 1er août 2026',
  'tyreOverview.searchHelp.example.vegaWet': 'Pneus Vega ou pneus pluie',

  // Devices
  'device.alfano7': 'Alfano 7',
  'device.mychron5': 'MyChron 5',

  // Import
  'import.title': 'Importer des sessions',
  'import.uploadZip': 'Téléverser des fichiers de télémétrie',
  'import.uploadZipDesc': 'Téléversez des fichiers de données de télémétrie Alfano 7 (ZIP) ou MyChron 5 (.xrk, .xrz, ZIP) depuis votre ordinateur',
  'import.dragDropZip': 'Glissez-déposez des fichiers ZIP, XRK ou XRZ ici',
  'import.dropZipHere': 'Déposez les fichiers ici',
  'import.orBrowse': 'ou',
  'import.browseFiles': 'parcourir les fichiers',
  'import.filesSelected': '{n} fichier(s) sélectionné(s)',
  'import.upload': 'Téléverser',
  'import.uploading': 'Téléversement…',
  'import.uploadingPct': 'Téléversement… {n}%',
  'import.imported': 'Importées',
  'import.skipped': 'Ignorées',
  'import.errors': 'Erreurs',
  'import.errorDetailsTitle': 'Détails des erreurs',
  'import.successMessage': 'Sessions importées avec succès. Elles apparaîtront dans votre tableau de bord.',
  'import.noNewSessions': 'Aucune nouvelle session trouvée. Tous les fichiers ont déjà été importés.',
  'import.onlyZipAccepted': 'Seuls les fichiers ZIP, XRK et XRZ sont acceptés',
  'import.onlySupportedAccepted': 'Seuls les fichiers ZIP, XRK et XRZ sont acceptés',
  'import.uploadFailed': 'Échec du téléversement (HTTP {status})',
  'import.connectionLost': 'Connexion perdue',
  'import.uploadAborted': 'Téléversement annulé',
  'import.importFailed': "Échec de l'importation",
  'import.importedFromZip': '{n} session(s) importée(s)',
  'import.zipImportFailed': "Échec de l'importation : {error}",
  'import.useCurrentSetup': 'Utiliser les réglages actuels',
  'offline.title': 'Vous êtes hors ligne',
  'offline.message': "Vous n'êtes actuellement pas connecté à Internet. Veuillez vérifier votre connexion réseau et réessayer.",
  'settings.uploadSessions': 'Téléverser des sessions',
  'settings.uploadSessionsDesc': 'Téléversez des fichiers de télémétrie Alfano 7 ou MyChron 5 pour importer vos données de session.',
  // Sharing
  'sharing.title': 'Partage',
  'sharing.searchPlaceholder': 'Rechercher des utilisateurs par nom ou e-mail...',
  'sharing.noUsersFound': 'Aucun utilisateur trouvé',
  'sharing.shareAll': 'Partager toutes les sessions',
  'sharing.shareSelected': 'Partager uniquement la sélection',
  'sharing.readOnly': 'Lecture seule',
  'sharing.readWrite': 'Lecture et écriture',
  'sharing.share': 'Partager',
  'sharing.myShares': 'Mes partages (sortants)',
  'sharing.sharedWithMe': 'Partagés avec moi (entrants)',
  'sharing.revoke': 'Révoquer',
  'sharing.leave': 'Quitter',
  'sharing.permissions': 'Autorisations',
  'sharing.sharedAll': 'Toutes les sessions',
  'sharing.sharedSelected': 'Sessions sélectionnées',
  'sharing.searching': 'Recherche…',
  'sharing.owner': 'Propriétaire : {name}',
  'sharing.selectSessions': 'Sélectionner des sessions',
  'sharing.noSessions': 'Aucune session disponible',
  'sharing.laps': 'tours',
  'sharing.searchHint': 'Saisissez au moins 2 caractères pour rechercher',
  'sharing.newShare': 'Nouveau partage',
  'sharing.stepUsers': 'Étape 1 : Sélectionner les utilisateurs',
  'sharing.stepConfigure': 'Étape 2 : Configurer le partage',
  'sharing.stepPermissions': 'Étape 3 : Autorisations',
  'sharing.next': 'Suivant',
  'sharing.selectedUsers': 'Utilisateurs sélectionnés',
  'sharing.selectedSessions': '{count} session(s) sélectionnée(s)',
  'sharing.filterSessions': 'Filtrer les sessions...',
  'sharing.showSelected': 'Afficher la sélection',
  'sharing.noSharesYet': 'Aucun partage pour le moment',
  'sharing.emptyDescription': 'Partagez vos sessions avec d’autres pilotes ou mécaniciens.',
  'sharing.stepScope': 'Étape 1 : Sélectionner les sessions',
  'sharing.stepConfirm': 'Étape 2 : Confirmer',
  'sharing.shareWithTeam': 'Partager avec cette équipe',

  // Session tabs

  // Setup (readonly view)
  'setup.noSetup': 'Aucune donnée de réglage disponible pour cette session.',
  'setup.loadingSetup': 'Chargement des réglages…',
  'setup.loadFailed': 'Échec du chargement des données de réglage.',
  'common.none': 'Aucun',
  'common.notSet': 'Non défini',
  'nav.setupSections': 'Sections de réglage',
  // Pressure
  'pressure.tyre': 'Train de pneus',
  'pressure.outgoing': 'Départ',
  'pressure.cold': 'à froid',
  'pressure.incoming': 'Retour',
  'pressure.hot': 'à chaud',
  'pressure.fl': 'AVG',
  'pressure.fr': 'AVD',
  'pressure.rl': 'ARG',
  'pressure.rr': 'ARD',
  // Front
  'front.caster': 'Chasse',
  'front.camber': 'Carrossage',
  'front.trackWidth': 'Largeur de voie avant',
  'front.trackWidthUnit': 'mm',
  'front.rideHeight': 'Hauteur de caisse avant',
  'front.frontHubs': 'Moyeux avant',
  'front.ackermann': 'Ackermann',
  'front.inner': 'Intérieur',
  'front.outer': 'Extérieur',
  'front.toeAlignment': 'Parallélisme',
  'front.torsionBar': 'Barre de torsion',
  'front.hard': 'Dure',
  'front.medium': 'Moyenne',
  'front.soft': 'Souple',
  // Rear
  'rear.axle': 'Arbre arrière',
  'rear.rearWidth': 'Largeur de voie arrière',
  'rear.rearHubs': 'Moyeux arrière',
  'rear.loosenedBumper': 'Pare-chocs arrière desserré',
  // Engine
  'engine.engine': 'Moteur',
  'engine.sparkPlug': 'Bougie',
  'engine.gearRatio': 'Rapport de transmission',
  'engine.pinion': 'Pignon',
  'engine.crown': 'Couronne',
  // Carburetor
  'carb.carburetor': 'Carburateur',
  'carb.mainJet': 'Gicleur principal',
  'carb.idleJet': 'Gicleur de ralenti',
  'carb.needleClip': "Cran d'aiguille",
  'carb.airScrew': "Vis d'air",
  'carb.floatHeight': 'Hauteur de flotteur',
  // Chassis
  'chassisSelect.chassis': 'Châssis',
  'chassisSelect.weight': 'Poids',
  // Notes
  'notes.notes': 'Notes',
  'notes.placeholder': 'Notes de réglage…',

  // Navigation – inventory
  'nav.inventory': 'Inventaire',
  'nav.organization': 'Organisation',
  'nav.setup': 'Réglages',

  // Materials — common
  'common.add': 'Ajouter',
  'common.save': 'Enregistrer',
  'common.create': 'Créer',
  'common.created': 'Créé le',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.optional': '(facultatif)',
  'common.brand': 'Marque',
  'common.type': 'Type',
  'materials.profile': 'Profil',
  'materials.selectProfile': 'Sélectionner un profil…',
  'common.nr': 'N°',
  'common.nrInfo': 'Numéro séquentiel permettant d’identifier cette entrée.',
  'common.team': 'Équipe',
  'common.year': 'Année',
  'common.stiffness': 'Rigidité',
  'common.width': 'Largeur',
  'common.position': 'Position',

  // Materials — CRUD
  'crud.requiredField': '{field} est requis',
  'crud.updated': '{entity} mis à jour',
  'crud.created': '{entity} créé',
  'crud.deleted': '{entity} supprimé',
  'crud.confirmDelete': 'Supprimer {entity} « {name} » ?\nCette action est irréversible.',
  'crud.emptyState': 'Aucun {title} pour le moment. Ajoutez votre premier {entity} ci-dessus.',
  'crud.editEntity': 'Modifier {entity}',
  'crud.newEntity': 'Nouveau {entity}',

  // Materials — general
  'materials.readOnly': 'Lecture seule',
  'materials.selectTeam': "Sélectionnez une équipe pour consulter l'inventaire.",

  // Materials — tabs
  'materials.tab.engines': 'Moteurs',
  'materials.tab.tyres': 'Pneus',
  'materials.tab.chassis': 'Châssis',
  'materials.tab.carburetors': 'Carburateurs',
  'materials.tab.axles': 'Arbres',
  'materials.tab.hubs': 'Moyeux',
  'materials.tab.spark_plugs': 'Bougies',

  // Materials — entities
  'materials.entity.engine': 'Moteur',
  'materials.entity.tyre': 'Pneu',
  'materials.entity.chassis': 'Châssis',
  'materials.entity.carburetor': 'Carburateur',
  'materials.entity.axle': 'Arbre',
  'materials.entity.hub': 'Moyeu',
  'materials.entity.spark_plug': 'Bougie',

  // Materials — tyre-specific
  'materials.tyre.compound': 'Gomme',
  'materials.tyre.compound.dry': 'Sec',
  'materials.tyre.compound.wet': 'Pluie',
  'materials.tyre.discarded': 'Mis au rebut',

  // Materials — tyre IDs
  'materials.tyreId.title': 'Identifiants des pneus',
  'materials.tyreId.fl': 'AVG',
  'materials.tyreId.fr': 'AVD',
  'materials.tyreId.rl': 'ARG',
  'materials.tyreId.rr': 'ARD',
  'materials.tyreId.scan': 'Scanner le code-barres',
  'materials.tyreId.duplicateInSet': 'Identifiant de pneu en double dans ce train',
  'materials.tyreId.duplicateInOtherSet': "L'identifiant {id} est déjà utilisé par {tyre}",
  'materials.tyreId.placeholder': "Scanner ou saisir l'identifiant du pneu",
  'materials.tyreId.crossSetInfo': 'Certains identifiants de pneus sont en conflit avec d’autres trains. Appuyez à nouveau sur Enregistrer pour forcer.',

  // Materials — hub positions
  'materials.position.front': 'Avant',
  'materials.position.rear': 'Arrière',
  // Setup editing
  'setup.edit': 'Modifier les réglages',
  'setup.editTitle': 'Modifier les réglages',
  'setup.save': 'Enregistrer les réglages',
  'setup.saving': 'Enregistrement…',
  'setup.saved': 'Réglages enregistrés',
  'setup.saveFailed': "Échec de l'enregistrement des réglages",
  'setup.pageTitle': 'Réglages actuels',
  'setup.pageSubtitle': 'Configuration de base pour les nouvelles sessions importées',
  'setup.editCurrentTitle': 'Modifier les réglages actuels',
  'setup.noCurrentSetup': 'Aucun réglage configuré pour le moment. Cliquez sur « Modifier les réglages » pour commencer.',
  // Propagation
  'propagation.title': 'Appliquer les modifications',
  'propagation.subtitle': 'Appliquer les modifications de réglages à d’autres sessions',
  'propagation.changes': 'Modifications',
  'propagation.sessions': 'Sessions',
  'propagation.selectAll': 'Tout sélectionner',
  'propagation.deselectAll': 'Tout désélectionner',
  'propagation.apply': 'Appliquer',
  'propagation.applying': 'Application…',
  'propagation.applied': 'Appliqué aux sessions',
  'propagation.skip': 'Ignorer',
  'propagation.selectAtLeastOne': 'Sélectionnez au moins une session',
  'propagation.noMatching': 'Aucune session correspondante trouvée',
  // Propagation field labels
  'propagation.field.chassis': 'Châssis',
  'propagation.field.weight': 'Poids',
  'propagation.field.engine': 'Moteur',
  'propagation.field.tyre': 'Pneus',
  'propagation.field.carburetor': 'Carburateur',
  'propagation.field.axle': 'Arbre',
  'propagation.field.flOut': 'AVG départ',
  'propagation.field.frOut': 'AVD départ',
  'propagation.field.rlOut': 'ARG départ',
  'propagation.field.rrOut': 'ARD départ',
  'propagation.field.flIn': 'AVG retour',
  'propagation.field.frIn': 'AVD retour',
  'propagation.field.rlIn': 'ARG retour',
  'propagation.field.rrIn': 'ARD retour',
  'propagation.field.rearWidth': 'Largeur arrière',
  'propagation.field.frontHubs': 'Moyeux avant',
  'propagation.field.rearHubs': 'Moyeux arrière',
  'propagation.field.rearBumper': 'Pare-chocs arrière',
  'propagation.field.caster': 'Chasse',
  'propagation.field.camber': 'Carrossage',
  'propagation.field.trackWidth': 'Largeur de voie avant',
  'propagation.field.rideHeight': 'Hauteur de caisse',
  'propagation.field.ackermann': 'Ackermann',
  'propagation.field.toe': 'Parallélisme',
  'propagation.field.torsionBar': 'Barre de torsion',
  'propagation.field.frontSprocket': 'Pignon',
  'propagation.field.rearSprocket': 'Couronne',
  'propagation.field.mainJet': 'Gicleur principal',
  'propagation.field.idleJet': 'Gicleur de ralenti',
  'propagation.field.needleClip': "Cran d'aiguille",
  'propagation.field.airScrew': "Vis d'air",
  'propagation.field.floatHeight': 'Hauteur de flotteur',
  'propagation.field.notes': 'Notes',
  'propagation.field.sparkPlug': 'Bougie',
  // Common additions
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.skip': 'Ignorer',
  'common.applying': 'Application…',

  // Teams
  'nav.teams': 'Équipes',
  'team.subtitle': 'Gérez vos équipes et leurs membres',
  'team.create': 'Créer une équipe',
  'team.name': "Nom de l'équipe",
  'team.members': 'Membres',
  'team.role.read': 'Lecture',
  'team.role.write': 'Écriture',
  'team.role.manage': 'Gestion',
  'team.role.owner': 'Propriétaire',
  'team.addMember': 'Ajouter un membre',
  'team.removeMember': 'Retirer le membre',
  'team.leave': "Quitter l'équipe",
  'team.confirmLeave': 'Voulez-vous vraiment quitter cette équipe ?',
  'team.cannotLeaveOwner': "Vous ne pouvez pas quitter l'équipe car vous en êtes le propriétaire.",
  'team.created': 'Équipe créée',
  'team.memberAdded': 'Membre ajouté',
  'team.memberRemoved': 'Membre retiré',
  'team.roleUpdated': 'Rôle mis à jour',
  'team.renamed': 'Équipe renommée',
  'team.empty': 'Aucune équipe trouvée. Créez-en une pour commencer.',
  'team.noWriteAccess': "Vous n'avez pas d'accès en écriture pour cette équipe.",
  'team.tab.members': 'Membres',
  'team.tab.sharing': 'Partage',
  'team.members.searchPlaceholder': 'Rechercher des membres...',
  'team.sharing.searchPlaceholder': 'Rechercher des partages...',
  'team.members.searchTitle': 'Rechercher des membres',
  'team.members.searchSubtitle': 'Filtrer les membres par nom, e-mail ou rôle',
  'team.sharing.searchTitle': 'Rechercher des partages',
  'team.sharing.searchSubtitle': 'Filtrer les partages par propriétaire ou par type',
  'team.members.field.bareText': '(texte libre)',
  'team.members.field.bareTextDesc': 'Recherche par nom',
  'team.members.field.name': 'name:',
  'team.members.field.nameDesc': 'Filtrer par nom de membre',
  'team.members.field.role': 'role:',
  'team.members.field.roleDesc': 'Filtrer par rôle (read, write, manage)',
  'team.sharing.field.bareText': '(texte libre)',
  'team.sharing.field.bareTextDesc': 'Recherche par nom du propriétaire',
  'team.sharing.field.owner': 'owner:',
  'team.sharing.field.ownerDesc': 'Filtrer par propriétaire du partage',
  'team.sharing.field.type': 'type:',
  'team.sharing.field.typeDesc': 'Filtrer par type (all, selected)',

  // Lap Diff Analysis
  'analysis.lapdiff.title': 'Comparaison de tours',
  'analysis.lapdiff.desc': 'Superposez deux tours et mettez en évidence les différences de vitesse, de RPM et d’accélération.',
  'lapdiff.selectHint': 'Sélectionnez exactement 2 tours à comparer.',
  'lapdiff.compare': 'Comparer',
  'lapdiff.comparing': 'Comparaison…',
  'lapdiff.viewLapA': 'Voir le tour A',
  'lapdiff.viewLapB': 'Voir le tour B',
  'lapdiff.tabTime': 'Temps',
  'lapdiff.tabSpeed': 'Vitesse',
  'lapdiff.tabRpm': 'RPM',
  'lapdiff.tabAcceleration': 'Accélération',
  'lapdiff.timeChartTitle': 'Temps perdu selon la position sur la piste',
  'lapdiff.timeGained': 'Temps gagné',
  'lapdiff.timeLost': 'Temps perdu',
  'lapdiff.cumulativeDelta': 'Δt cumulé',
  'lapdiff.segmentDelta': 'Δt segment',
  'lapdiff.trackPosition': 'Position sur la piste',
  'lapdiff.avgDiff': 'Écart moy.',
  'lapdiff.maxDiff': 'Écart max.',
  'lapdiff.noGpsData': 'Aucune donnée GPS disponible pour la comparaison.',
  'lapdiff.pctBetter': '% meilleur',
  'lapdiff.segmentTime': 'Segment',
  'lapdiff.fullLap': 'Tour complet',
  'lapdiff.fasterBy': '{lap} plus rapide de {time}',
  'lapdiff.equalTime': 'Temps identique',
  'lapdiff.clearAnchors': 'Effacer les repères',
  'lapdiff.clickToPlace': 'Cliquez sur la piste pour placer des repères',
  'lapdiff.segmentRange': 'Segments n°{start} – n°{end}',
  'lapdiff.segmentDetail': 'Segment n°{index}',

  // Aggregation Analysis
  'analysis.aggregation.title': 'Agrégation',
  'analysis.aggregation.desc': 'Agrégez les points de freinage, d’accélération et de passage de rapport sur une carte de piste à travers plusieurs sessions.',
  'aggregation.brakingPoints': 'Freinage',
  'aggregation.accelerationPoints': 'Accélération',
  'aggregation.upshiftPoints': 'Passage de rapport',
  'aggregation.top10Title': 'Top 10 des meilleurs tours',
  'aggregation.noData': 'Aucun point de données détecté',
  'aggregation.noDataHint': 'Essayez de sélectionner d’autres sessions.',
  'aggregation.trackShapeRequired': 'Tracé de piste requis',
  'aggregation.trackShapeRequiredHint': "Un tracé de piste officiel est requis pour afficher les boîtes à moustaches d'agrégation. Veuillez créer un tracé de piste dans l'éditeur.",
  'aggregation.sessionSelectionHint': 'Plus vous incluez de sessions, plus la qualité et la précision des zones agrégées seront élevées.',
  'aggregation.brakingSegment': 'Zone de freinage',
  'aggregation.accelerationSegment': "Zone d'accélération",
  'aggregation.upshiftSegment': 'Zone de passage de rapport',
  'aggregation.tooltipSamples': ({ count }) => `${count} échantillons`,
  'aggregation.tooltipMedian': 'Médiane',
  'aggregation.tooltipSpread': 'Dispersion',
  'aggregation.gpsHeatmap': 'Carte thermique GPS',
  'aggregation.eventZones': "Zones d'événements",
  'aggregation.heatmapLow': 'Faible',
  'aggregation.heatmapHigh': 'Élevée',
  'aggregation.selectedLapLine': 'Tour sélectionné',
  'aggregation.lapsIncluded': '{count} tours',
  'gearshifting.wizardChooseTrack': 'Choisir la piste',
  'gearshifting.wizardSelect': 'Sélectionner les sessions',
  'gearshifting.wizardResults': 'Résultats',
  'gearshifting.analyzingLap': 'Analyse en cours…',

  // Aggregation Diff Analysis
  'analysis.aggregationdiff.title': "Comparaison d'agrégations",
  'analysis.aggregationdiff.desc': 'Comparez deux agrégations de sessions pour mettre en évidence les différences de trajectoire, de freinage, d’accélération et de passage de rapport.',
  'aggregationdiff.groupA': 'Groupe A',
  'aggregationdiff.groupB': 'Groupe B',
  'aggregationdiff.baseline': 'Référence',
  'aggregationdiff.comparison': 'Comparaison',
  'aggregationdiff.groupLabelPlaceholder': 'Libellé personnalisé (p. ex. Matin sec)',
  'aggregationdiff.loadSavedAggregation': 'Charger depuis une agrégation enregistrée…',
  'aggregationdiff.selectHint': 'Sélectionnez les sessions pour le Groupe A (Référence) et le Groupe B (Comparaison) afin de mettre en évidence les différences de trajectoire, de freinage, d’accélération et de passage de rapport.',
  'aggregationdiff.selectHintA': 'Configurez le Groupe A (Référence) en sélectionnant un tour unique ou une ou plusieurs sessions.',
  'aggregationdiff.selectHintB': 'Configurez le Groupe B (Comparaison) en sélectionnant un tour unique ou une ou plusieurs sessions à comparer au Groupe A.',
  'aggregationdiff.compare': 'Comparer les agrégations',
  'aggregationdiff.bestLap': 'Meilleur tour',
  'aggregationdiff.medianLap': 'Tour médian',
  'aggregationdiff.consistency': 'Régularité (σ)',
  'aggregationdiff.lapsAndSessions': '{laps} tours · {sessions} sessions',
  'aggregationdiff.layerDiffHeatmap': 'Carte thermique des écarts de trajectoire',
  'aggregationdiff.layerMedianLines': 'Trajectoires médianes',
  'aggregationdiff.layerEventDiffs': "Écarts de zones d'événements",
  'aggregationdiff.hideUnchanged': 'Atténuer < 1,5 m',
  'aggregationdiff.keyDifferencesTitle': 'Différences clés',
  'aggregationdiff.keyDifferencesSubtitle': 'Sections de piste triées par écart de temps avec causes possibles. Cliquez sur une section pour centrer la carte.',
  'aggregationdiff.filterAll': 'Tout',
  'aggregationdiff.filterLine': 'Trajectoire',
  'aggregationdiff.filterBraking': 'Freinage',
  'aggregationdiff.filterAcceleration': 'Accélération',
  'aggregationdiff.filterUpshift': 'Passage de rapport',
  'aggregationdiff.filterTopSpeed': 'Vitesse max.',
  'aggregationdiff.possibleReasons': 'Causes possibles',
  'aggregationdiff.topSpeedPeak': 'Pic {a} vs {b} km/h',
  'aggregationdiff.laterBy': '{group} {dist} m plus tard',
  'aggregationdiff.earlierBy': '{group} {dist} m plus tôt',
  'aggregationdiff.widerBy': 'Dispersion +{dist} m plus large',
  'aggregationdiff.tighterBy': 'Dispersion {dist} m plus serrée',
  'aggregationdiff.onlyInGroup': 'Uniquement dans {group}',
  'aggregationdiff.lineSeparation': 'Écart de trajectoire max. de {dist} m (zone de {len} m)',
  'aggregationdiff.lineOffsetLeft': 'Gauche +{dist} m',
  'aggregationdiff.lineOffsetRight': 'Droite +{dist} m',
  'aggregationdiff.noSignificantDiffs': 'Aucune différence significative trouvée pour ce filtre.',
  'aggregationdiff.sharedLine': 'Trajectoire commune',
  'aggregationdiff.clearFocus': 'Effacer la sélection',
  'aggregationdiff.avgSpeed': 'Vitesse moy.',
  'aggregationdiff.speedDiff': 'Écart de vitesse',
  'aggregationdiff.lineOffset': 'Décalage de trajectoire',
  'aggregationdiff.layerFasterSegments': 'Segments plus rapides',
  'aggregationdiff.fasterSegmentLegend': 'Segment plus rapide (vitesse)',
  'aggregationdiff.estTimeGained': '{group} plus rapide de {time}',
  'aggregationdiff.estTimeLost': '{group} plus rapide de {time}',
  'aggregationdiff.estTimeNeutral': 'Est. ±0,00 s',

  // Analysis History
  'analysis.history.title': 'Historique des analyses',
  'analysis.history.subtitle': 'Rouvrez et gérez les analyses de télémétrie précédemment évaluées',
  'analysis.history.filterAll': 'Tous les outils',
  'analysis.history.filterSector': 'Secteur',
  'analysis.history.filterCorner': 'Virage',
  'analysis.history.filterBraking': 'Freinage',
  'analysis.history.filterLapDiff': 'Comp. de tours',
  'analysis.history.filterAggregation': 'Agrégation',
  'analysis.history.filterAggregationDiff': "Comp. d'agrégations",
  'analysis.history.groupsScope': '{a} vs {b} session(s)',
  'analysis.history.empty': 'Aucune analyse enregistrée trouvée',
  'analysis.history.emptyDesc': 'Les analyses que vous exécutez en étant connecté apparaîtront automatiquement ici.',
  'analysis.history.open': 'Ouvrir',
  'analysis.history.rename': 'Renommer',
  'analysis.history.delete': 'Supprimer',
  'analysis.history.deleteConfirm': "Voulez-vous vraiment supprimer cette analyse de l'historique ?",
  'analysis.history.deleteSuccess': 'Analyse supprimée',
  'analysis.history.renameSuccess': 'Analyse renommée',
  'analysis.history.searchPlaceholder': "Rechercher dans l'historique des analyses...",
  'analysis.history.loading': 'Chargement des analyses...',
  'analysis.history.table.type': 'Type',
  'analysis.history.table.name': 'Nom',
  'analysis.history.table.track': 'Piste',
  'analysis.history.table.scope': 'Portée',
  'analysis.history.table.created': 'Créée le',
  'analysis.history.table.actions': 'Actions',
  'analysis.history.total': '{n} au total',
  'analysis.history.sessionsCount': '{n} session(s)',
  'analysis.history.lapsCount': '{n} tour(s)',
  'analysis.history.viewAll': "Voir tout l'historique",
  'analysis.sessionRemoved.title': 'Session supprimée',
  'analysis.sessionRemoved.description': 'La session de télémétrie utilisée par cette analyse a été supprimée et cette analyse ne peut plus être ouverte.',
  'analysis.sessionRemoved.deleteAnalysis': "Supprimer l'analyse",
  'analysis.sessionRemoved.close': 'Fermer',

  /* ── Footer ──── */
  'footer.contact': 'Contact',
  'footer.privacyPolicy': 'Politique de confidentialité',
  'footer.reportBug': 'Signaler un bug',
  'footer.bugReportTitle': 'Signaler un bug',
  'footer.description': 'Description',
  'footer.descriptionPlaceholder': 'Décrivez le problème rencontré...',
  'footer.submit': 'Envoyer',
  'footer.submitting': 'Envoi en cours...',
  'footer.submitted': 'Signalement de bug envoyé. Merci !',
  'footer.submitFailed': "Échec de l'envoi du signalement de bug.",

  /* ── Error auto-reporting & Error Boundary ─────────────────────────── */
  'error.autoReported': 'Une erreur est survenue et a été automatiquement signalée.',
  'errorBoundary.title': 'Une erreur est survenue',
  'errorBoundary.message': 'Une erreur inattendue est survenue et a été signalée au serveur.',
  'errorBoundary.reload': 'Recharger la page',
  'errorBoundary.reset': 'Réessayer',
  'errorBoundary.showDetails': "Afficher les détails de l'erreur",
  'errorBoundary.hideDetails': "Masquer les détails de l'erreur",

  /* ── Setup Coach ──────────────────────────────────────────── */
  'coach.title': 'Assistant de réglages',
  'coach.subtitle': 'Une base de connaissances des réglages de kart organisée par objectif de pilotage. Sélectionnez un problème pour voir les modifications recommandées et leurs effets.',
  'coach.disclaimer': "Ces recommandations sont des lignes directrices générales pour les karts Rotax Max. Testez toujours les modifications progressivement et ajustez-les selon l'état de la piste, le ressenti du pilote et l'usure des pneus.",
  'coach.col.parameter': 'Paramètre',
  'coach.col.change': 'Modification',
  'coach.col.effect': 'Effet',
  'coach.col.sideEffects': 'Effets secondaires',
  'coach.col.effectiveness': 'Efficacité',

  // Reduce Understeer
  'coach.goal.understeer.title': 'Réduire le sous-virage',
  'coach.goal.understeer.desc': "Le kart élargit la trajectoire en virage et ne suit pas la ligne voulue. Les pneus avant perdent de l'adhérence avant l'arrière, rendant le kart peu réactif au braquage.",
  'coach.goal.understeer.adj1.param': 'Largeur de voie avant',
  'coach.goal.understeer.adj1.change': 'Élargir',
  'coach.goal.understeer.adj1.effect': "Plus d'adhérence mécanique à l'avant",
  'coach.goal.understeer.adj1.side': "Peut augmenter l'agressivité du train avant",
  'coach.goal.understeer.adj2.param': 'Chasse avant',
  'coach.goal.understeer.adj2.change': 'Augmenter',
  'coach.goal.understeer.adj2.effect': "Plus d'adhérence avant à l'inscription en virage",
  'coach.goal.understeer.adj2.side': 'Moins de stabilité en ligne droite',
  'coach.goal.understeer.adj3.param': 'Carrossage avant',
  'coach.goal.understeer.adj3.change': 'Ajouter (plus négatif)',
  'coach.goal.understeer.adj3.effect': "Plus d'adhérence avant en milieu de virage",
  'coach.goal.understeer.adj3.side': 'Usure irrégulière des pneus',
  'coach.goal.understeer.adj4.param': 'Hauteur de caisse avant',
  'coach.goal.understeer.adj4.change': 'Abaisser',
  'coach.goal.understeer.adj4.effect': 'Centre de gravité plus bas, plus de grip',
  'coach.goal.understeer.adj4.side': 'Risque de talonnage du châssis',
  'coach.goal.understeer.adj5.param': 'Arbre arrière',
  'coach.goal.understeer.adj5.change': 'Plus souple (moins rigide)',
  'coach.goal.understeer.adj5.effect': "Libère l'arrière pour faciliter la rotation",
  'coach.goal.understeer.adj5.side': "Peut provoquer une instabilité de l'arrière",
  'coach.goal.understeer.adj6.param': 'Pression des pneus avant',
  'coach.goal.understeer.adj6.change': 'Augmenter légèrement',
  'coach.goal.understeer.adj6.effect': 'Réponse du train avant plus incisive',
  'coach.goal.understeer.adj6.side': 'Surface de contact réduite',

  // Reduce Oversteer
  'coach.goal.oversteer.title': 'Réduire le survirage',
  'coach.goal.oversteer.desc': "L'arrière du kart décroche en virage, faisant pivoter le kart trop brusquement. Les pneus arrière perdent de l'adhérence avant l'avant, entraînant un survirage brutal ou un train arrière instable.",
  'coach.goal.oversteer.adj1.param': 'Largeur de voie avant',
  'coach.goal.oversteer.adj1.change': 'Rétrécir',
  'coach.goal.oversteer.adj1.effect': 'Moins de grip avant, équilibre le comportement',
  'coach.goal.oversteer.adj1.side': 'Direction moins incisive',
  'coach.goal.oversteer.adj2.param': 'Chasse avant',
  'coach.goal.oversteer.adj2.change': 'Réduire',
  'coach.goal.oversteer.adj2.effect': "Moins d'adhérence avant",
  'coach.goal.oversteer.adj2.side': 'Inscription en virage plus lente',
  'coach.goal.oversteer.adj3.param': 'Arbre arrière',
  'coach.goal.oversteer.adj3.change': 'Rigidifier',
  'coach.goal.oversteer.adj3.effect': "Plus d'adhérence à l'arrière",
  'coach.goal.oversteer.adj3.side': 'Le châssis peut rebondir sur les bosses',
  'coach.goal.oversteer.adj4.param': 'Largeur de voie arrière',
  'coach.goal.oversteer.adj4.change': 'Élargir',
  'coach.goal.oversteer.adj4.effect': "Plus d'adhérence mécanique à l'arrière",
  'coach.goal.oversteer.adj4.side': "Moins de rotation de l'arrière",
  'coach.goal.oversteer.adj5.param': 'Pression des pneus arrière',
  'coach.goal.oversteer.adj5.change': 'Réduire légèrement',
  'coach.goal.oversteer.adj5.effect': "Plus grande surface de contact à l'arrière",
  'coach.goal.oversteer.adj5.side': 'Mise en température des pneus plus lente',
  'coach.goal.oversteer.adj6.param': 'Barre de torsion avant',
  'coach.goal.oversteer.adj6.change': 'Ajouter',
  'coach.goal.oversteer.adj6.effect': "Rigidifie l'avant, réduit le grip avant",
  'coach.goal.oversteer.adj6.side': 'Moins de souplesse du train avant',

  // Chassis Bounce
  'coach.goal.bounce.title': 'Le châssis rebondit en virage',
  'coach.goal.bounce.desc': "Le châssis sautille ou rebondit en virage au lieu de maintenir un contact fluide avec la piste. Cela est généralement dû à un châssis trop rigide par rapport au niveau d'adhérence, empêchant de conserver une vitesse régulière en courbe.",
  'coach.goal.bounce.adj1.param': 'Arbre arrière',
  'coach.goal.bounce.adj1.change': 'Plus souple (moins rigide)',
  'coach.goal.bounce.adj1.effect': "Absorbe l'énergie, adoucit le comportement",
  'coach.goal.bounce.adj1.side': "Peut réduire l'adhérence arrière",
  'coach.goal.bounce.adj2.param': 'Largeur de voie arrière',
  'coach.goal.bounce.adj2.change': 'Élargir',
  'coach.goal.bounce.adj2.effect': 'Stabilise le châssis en virage',
  'coach.goal.bounce.adj2.side': 'Moins de rotation en sortie',
  'coach.goal.bounce.adj3.param': 'Pare-chocs arrière',
  'coach.goal.bounce.adj3.change': 'Desserrer',
  'coach.goal.bounce.adj3.effect': 'Ajoute de la flexibilité, absorbe les vibrations',
  'coach.goal.bounce.adj3.side': 'Maintien moins rigide',
  'coach.goal.bounce.adj4.param': 'Pression des pneus arrière',
  'coach.goal.bounce.adj4.change': 'Réduire',
  'coach.goal.bounce.adj4.effect': 'Plus de souplesse sur les bosses',
  'coach.goal.bounce.adj4.side': 'Réponse plus lente',
  'coach.goal.bounce.adj5.param': 'Hauteur de caisse avant',
  'coach.goal.bounce.adj5.change': 'Rehausser',
  'coach.goal.bounce.adj5.effect': 'Plus de garde au sol du châssis',
  'coach.goal.bounce.adj5.side': "Moins d'adhérence avant",

  // Reduce Front Aggressiveness
  'coach.goal.frontAggressive.title': "Réduire l'agressivité du train avant",
  'coach.goal.frontAggressive.desc': "Le train avant a trop de mordant, ce qui fait plonger le kart trop brusquement à la corde et déstabilise l'arrière. Le kart paraît nerveux en entrée de virage et peut décrocher en survirage.",
  'coach.goal.frontAggressive.adj1.param': 'Largeur de voie avant',
  'coach.goal.frontAggressive.adj1.change': 'Rétrécir',
  'coach.goal.frontAggressive.adj1.effect': "Réduit l'adhérence avant",
  'coach.goal.frontAggressive.adj1.side': 'Tendance accrue au sous-virage',
  'coach.goal.frontAggressive.adj2.param': 'Chasse avant',
  'coach.goal.frontAggressive.adj2.change': 'Réduire',
  'coach.goal.frontAggressive.adj2.effect': "Moins de mordant avant à l'inscription",
  'coach.goal.frontAggressive.adj2.side': 'Inscription en virage plus lente',
  'coach.goal.frontAggressive.adj3.param': 'Barre de torsion avant',
  'coach.goal.frontAggressive.adj3.change': 'Retirer ou assouplir',
  'coach.goal.frontAggressive.adj3.effect': 'Assouplit le train avant',
  'coach.goal.frontAggressive.adj3.side': "L'avant peut manquer de précision",
  'coach.goal.frontAggressive.adj4.param': 'Carrossage avant',
  'coach.goal.frontAggressive.adj4.change': 'Réduire (moins négatif)',
  'coach.goal.frontAggressive.adj4.effect': "Moins d'adhérence en appui",
  'coach.goal.frontAggressive.adj4.side': 'Usure des pneus plus régulière',
  'coach.goal.frontAggressive.adj5.param': 'Pression des pneus avant',
  'coach.goal.frontAggressive.adj5.change': 'Augmenter',
  'coach.goal.frontAggressive.adj5.effect': 'Surface de contact plus réduite',
  'coach.goal.frontAggressive.adj5.side': 'Plus vif mais moins de grip',

  // Reduce Rear Sliding
  'coach.goal.rearSlide.title': 'Réduire la glisse du train arrière',
  'coach.goal.rearSlide.desc': "L'arrière du kart glisse excessivement en virage, entraînant une perte de temps et une usure prématurée des pneus. Le kart manque de motricité arrière et semble instable sous forte charge latérale.",
  'coach.goal.rearSlide.adj1.param': 'Arbre arrière',
  'coach.goal.rearSlide.adj1.change': 'Rigidifier',
  'coach.goal.rearSlide.adj1.effect': "Plus d'adhérence à l'arrière",
  'coach.goal.rearSlide.adj1.side': 'Peut rebondir sur les bosses',
  'coach.goal.rearSlide.adj2.param': 'Largeur de voie arrière',
  'coach.goal.rearSlide.adj2.change': 'Élargir',
  'coach.goal.rearSlide.adj2.effect': "Plus d'adhérence mécanique à l'arrière",
  'coach.goal.rearSlide.adj2.side': 'Rotation moins libre',
  'coach.goal.rearSlide.adj3.param': 'Pression des pneus arrière',
  'coach.goal.rearSlide.adj3.change': 'Augmenter légèrement',
  'coach.goal.rearSlide.adj3.effect': 'Meilleure tenue du pneu sous charge',
  'coach.goal.rearSlide.adj3.side': 'Surface de contact réduite aux limites',
  'coach.goal.rearSlide.adj4.param': 'Largeur de voie avant',
  'coach.goal.rearSlide.adj4.change': 'Rétrécir',
  'coach.goal.rearSlide.adj4.effect': "Équilibre la répartition d'adhérence",
  'coach.goal.rearSlide.adj4.side': 'Moins de mordant à l’avant',
  'coach.goal.rearSlide.adj5.param': 'Moyeux arrière',
  'coach.goal.rearSlide.adj5.change': 'Utiliser des moyeux plus longs',
  'coach.goal.rearSlide.adj5.effect': "Plus de bras de levier à l'arrière",
  'coach.goal.rearSlide.adj5.side': 'Direction plus lourde',

  // Corner Exit Traction
  'coach.goal.cornerExit.title': 'Améliorer la motricité en sortie de virage',
  'coach.goal.cornerExit.desc': 'Le kart peine à passer la puissance au sol en sortie de virage, avec les pneus arrière qui patinent ou glissent à la réaccélération dans les virages lents. Cela fait perdre du temps à la relance vers la ligne droite.',
  'coach.goal.cornerExit.adj1.param': 'Largeur de voie arrière',
  'coach.goal.cornerExit.adj1.change': 'Élargir',
  'coach.goal.cornerExit.adj1.effect': "Plus d'adhérence mécanique en sortie",
  'coach.goal.cornerExit.adj1.side': 'Moins de rotation en milieu de virage',
  'coach.goal.cornerExit.adj2.param': 'Arbre arrière',
  'coach.goal.cornerExit.adj2.change': 'Rigidifier',
  'coach.goal.cornerExit.adj2.effect': "Plaque l'arrière à l'accélération",
  'coach.goal.cornerExit.adj2.side': 'Peut rebondir sous forte charge',
  'coach.goal.cornerExit.adj3.param': 'Pression des pneus arrière',
  'coach.goal.cornerExit.adj3.change': 'Abaisser',
  'coach.goal.cornerExit.adj3.effect': 'Plus grande surface de contact en sortie',
  'coach.goal.cornerExit.adj3.side': 'Mise en température des pneus plus lente',
  'coach.goal.cornerExit.adj4.param': 'Couronne arrière',
  'coach.goal.cornerExit.adj4.change': 'Augmenter (plus de dents)',
  'coach.goal.cornerExit.adj4.effect': 'Plus de couple à bas régime',
  'coach.goal.cornerExit.adj4.side': 'Vitesse de pointe réduite',
  'coach.goal.cornerExit.adj5.param': 'Pare-chocs arrière',
  'coach.goal.cornerExit.adj5.change': 'Desserrer',
  'coach.goal.cornerExit.adj5.effect': 'Plus de flexibilité sous charge',
  'coach.goal.cornerExit.adj5.side': 'Comportement moins prévisible',

  // Hot Conditions
  'coach.goal.hotConditions.title': "S'adapter aux conditions chaudes",
  'coach.goal.hotConditions.desc': "La température de la piste est élevée, ce qui augmente le grip et fait surchauffer les pneus. Le châssis peut sembler coller à la piste, provoquant des rebonds ou un train avant trop agressif. Le moteur chauffe davantage et une carburation plus riche peut être nécessaire.",
  'coach.goal.hotConditions.adj1.param': 'Toutes les pressions de pneus',
  'coach.goal.hotConditions.adj1.change': 'Augmenter',
  'coach.goal.hotConditions.adj1.effect': 'Compense la dilatation thermique',
  'coach.goal.hotConditions.adj1.side': "Peut réduire l'adhérence si trop élevée",
  'coach.goal.hotConditions.adj2.param': 'Gicleur principal',
  'coach.goal.hotConditions.adj2.change': 'Enrichir (numéro plus grand)',
  'coach.goal.hotConditions.adj2.effect': 'Évite un mélange trop pauvre',
  'coach.goal.hotConditions.adj2.side': 'Légère perte de puissance',
  'coach.goal.hotConditions.adj3.param': 'Arbre arrière',
  'coach.goal.hotConditions.adj3.change': 'Assouplir',
  'coach.goal.hotConditions.adj3.effect': "Compense l'augmentation du grip",
  'coach.goal.hotConditions.adj3.side': 'Peut sembler moins stable',
  'coach.goal.hotConditions.adj4.param': 'Largeur de voie arrière',
  'coach.goal.hotConditions.adj4.change': 'Rétrécir légèrement',
  'coach.goal.hotConditions.adj4.effect': "Réduit l'excès de grip arrière",
  'coach.goal.hotConditions.adj4.side': 'Moins de motricité en sortie',
  'coach.goal.hotConditions.adj5.param': "Vis d'air",
  'coach.goal.hotConditions.adj5.change': 'Ouvrir (dévisser davantage)',
  'coach.goal.hotConditions.adj5.effect': 'Mélange de ralenti plus riche',
  'coach.goal.hotConditions.adj5.side': 'Peut affecter la qualité du ralenti',

  // Cold/Wet Conditions
  'coach.goal.coldConditions.title': "S'adapter aux conditions froides / humides",
  'coach.goal.coldConditions.desc': "La température de la piste est basse ou la surface est mouillée, réduisant fortement l'adhérence. Le kart a besoin d'un grip mécanique maximal et la carburation doit compenser l'air plus dense. Effectuez les réglages avec prudence et privilégiez la sécurité du pilote.",
  'coach.goal.coldConditions.adj1.param': 'Toutes les pressions de pneus',
  'coach.goal.coldConditions.adj1.change': 'Réduire',
  'coach.goal.coldConditions.adj1.effect': 'Compense la contraction due au froid',
  'coach.goal.coldConditions.adj1.side': 'Risque de déjantage du pneu',
  'coach.goal.coldConditions.adj2.param': 'Gicleur principal',
  'coach.goal.coldConditions.adj2.change': 'Appauvrir (numéro plus petit)',
  'coach.goal.coldConditions.adj2.effect': "Compense l'air plus dense",
  'coach.goal.coldConditions.adj2.side': 'Risque de surchauffe du moteur',
  'coach.goal.coldConditions.adj3.param': 'Arbre arrière',
  'coach.goal.coldConditions.adj3.change': 'Rigidifier',
  'coach.goal.coldConditions.adj3.effect': "Génère plus d'adhérence mécanique",
  'coach.goal.coldConditions.adj3.side': 'Peut rebondir sur piste mouillée',
  'coach.goal.coldConditions.adj4.param': 'Largeur de voie avant et arrière',
  'coach.goal.coldConditions.adj4.change': 'Élargir les deux',
  'coach.goal.coldConditions.adj4.effect': "Maximise l'adhérence mécanique",
  'coach.goal.coldConditions.adj4.side': 'Comportement plus agressif',
  'coach.goal.coldConditions.adj5.param': "Vis d'air",
  'coach.goal.coldConditions.adj5.change': 'Fermer (visser davantage)',
  'coach.goal.coldConditions.adj5.effect': 'Mélange de ralenti plus pauvre',
  'coach.goal.coldConditions.adj5.side': 'Peut affecter le démarrage à froid',

  // Braking Stability
  'coach.goal.braking.title': 'Améliorer la stabilité au freinage',
  'coach.goal.braking.desc': "Le kart est instable au freinage, avec l'arrière qui se dérobe ou l'avant qui bloque. Cela rend difficile un freinage tardif et régulier, faisant perdre du temps en entrée de virage.",
  'coach.goal.braking.adj1.param': 'Pression des pneus avant',
  'coach.goal.braking.adj1.change': 'Augmenter',
  'coach.goal.braking.adj1.effect': 'Train avant plus précis au freinage',
  'coach.goal.braking.adj1.side': 'Surface de contact au freinage réduite',
  'coach.goal.braking.adj2.param': 'Chasse avant',
  'coach.goal.braking.adj2.change': 'Augmenter',
  'coach.goal.braking.adj2.effect': 'Plus de chasse, stabilise au freinage',
  'coach.goal.braking.adj2.side': 'Direction plus lourde',
  'coach.goal.braking.adj3.param': 'Hauteur de caisse avant',
  'coach.goal.braking.adj3.change': 'Abaisser',
  'coach.goal.braking.adj3.effect': "Plus de transfert de charge vers l'avant",
  'coach.goal.braking.adj3.side': 'Risque de talonnage',
  'coach.goal.braking.adj4.param': 'Barre de torsion avant',
  'coach.goal.braking.adj4.change': 'Ajouter',
  'coach.goal.braking.adj4.effect': 'Rigidifie le train avant au freinage',
  'coach.goal.braking.adj4.side': "Peut réduire le grip à l'inscription",
  'coach.goal.braking.adj5.param': 'Pression des pneus arrière',
  'coach.goal.braking.adj5.change': 'Réduire',
  'coach.goal.braking.adj5.effect': 'Évite le blocage des roues arrière',
  'coach.goal.braking.adj5.side': 'Réponse du train arrière plus lente',

  // Engine Tuning
  'coach.goal.engine.title': 'Affiner les performances du moteur',
  'coach.goal.engine.desc': 'Optimisez le rendement du moteur grâce aux réglages de transmission et de carburateur. Ces modifications influencent la délivrance de puissance, l’accélération, la vitesse de pointe et la fiabilité du moteur. Surveillez toujours la température des gaz d’échappement (EGT) lors d’un changement de gicleur.',
  'coach.goal.engine.adj1.param': 'Couronne arrière',
  'coach.goal.engine.adj1.change': 'Augmenter (plus de dents)',
  'coach.goal.engine.adj1.effect': "Plus d'accélération, vitesse de pointe réduite",
  'coach.goal.engine.adj1.side': 'Régime moteur (RPM) plus élevé en ligne droite',
  'coach.goal.engine.adj2.param': 'Couronne arrière',
  'coach.goal.engine.adj2.change': 'Diminuer (moins de dents)',
  'coach.goal.engine.adj2.effect': "Vitesse de pointe plus élevée, moins d'accélération",
  'coach.goal.engine.adj2.side': 'RPM plus bas, relances plus lentes',
  'coach.goal.engine.adj3.param': 'Gicleur principal',
  'coach.goal.engine.adj3.change': 'Enrichir (numéro plus grand)',
  'coach.goal.engine.adj3.effect': 'EGT plus basse, plus sûr pour le moteur',
  'coach.goal.engine.adj3.side': 'Légère perte de puissance',
  'coach.goal.engine.adj4.param': 'Gicleur principal',
  'coach.goal.engine.adj4.change': 'Appauvrir (numéro plus petit)',
  'coach.goal.engine.adj4.effect': 'Plus de puissance',
  'coach.goal.engine.adj4.side': 'Risque de serrage, EGT plus élevée',
  'coach.goal.engine.adj5.param': "Cran d'aiguille",
  'coach.goal.engine.adj5.change': 'Monter le clip (abaisser l’aiguille)',
  'coach.goal.engine.adj5.effect': 'Mi-régime plus pauvre, plus de puissance',
  'coach.goal.engine.adj5.side': 'Risque de mélange trop pauvre',
  'coach.goal.engine.adj6.param': 'Hauteur de flotteur',
  'coach.goal.engine.adj6.change': 'Ajuster',
  'coach.goal.engine.adj6.effect': 'Contrôle le niveau de carburant dans la cuve',
  'coach.goal.engine.adj6.side': 'Affecte toutes les plages de régime',

  // Track Map Controls
  'trackMap.zoomIn': 'Zoomer',
  'trackMap.zoomOut': 'Dézoomer',
  'trackMap.fitTrack': 'Ajuster à la piste',
  'trackMap.satellite': 'Satellite',
  'trackMap.vector': 'Vecteur',
  'trackMap.switchProvider': "Changer de fournisseur d'imagerie aérienne",

  // Lap Analysis Queue & Amended Analysis
  'queue.processingLaps': 'Analyse des tours {done}/{total}',
  'queue.completed': 'Analyse des tours terminée ({total}/{total})',
  'tracks.reanalyzeLaps': 'Réanalyser les tours',
  'tracks.reanalyzingLaps': 'Mise en file d’attente…',
  'tracks.reanalyzeQueued': '{enqueued} tour(s) mis en file d’attente pour analyse ({skipped} déjà à jour).',
  'tracks.reanalyzeAllUpToDate': 'Les {skipped} tour(s) sont déjà tous à jour avec les données actuelles de la piste.',
  'lapInfo.canonicalSectors': 'Secteurs de la piste',
  'lapInfo.loggerSectors': "Secteurs de l'enregistreur",
  'lapAnalysis.amendedCornersTitle': 'Détail des virages et du freinage',
  'lapAnalysis.cornerCol': 'Virage',
  'lapAnalysis.topApproachSpeed': 'Vitesse max avant freinage',
  'lapAnalysis.slowestSpeed': 'Vitesse la plus basse',
  'lapAnalysis.apexSpeed': 'Vitesse au point de corde',
  'lapAnalysis.exitSpeed': 'Vitesse de sortie',
  'lapAnalysis.brakingDist': 'Dist. de freinage',
  'lapAnalysis.cornerTime': 'Durée',
  'lapAnalysis.statusCompleted': 'Analyse terminée',
  'lapAnalysis.statusPending': 'Analyse en attente',
  'session.tabCorners': 'Virages',
  'session.noCornersConfigured': 'Aucune donnée d’analyse de virage disponible pour cette session.',
  'lapAnalysis.entrySpeed': "Vitesse d'entrée",
  'lapAnalysis.trailBraking': 'Freinage dégressif',

  // Terms & Conditions
  'footer.termsAndConditions': "Conditions générales d'utilisation",
  'terms.gateTitle': "Conditions générales d'utilisation",
  'terms.gateSubtitle': "Veuillez consulter et accepter les dernières Conditions générales d'utilisation pour continuer.",
  'terms.updatedBannerTitle': "Conditions générales d'utilisation mises à jour :",
  'terms.updatedBannerDesc': "Nos Conditions générales d'utilisation ont été mises à jour. Veuillez consulter et accepter la nouvelle version pour continuer à utiliser kart.win.",
  'terms.checkboxLabel': "J'ai lu et j'accepte les Conditions générales d'utilisation",
  'terms.acceptButton': 'Accepter et continuer',
  'terms.acceptingButton': 'Acceptation…',
  'terms.loadError': "Impossible de charger les Conditions générales d'utilisation. Veuillez vérifier votre connexion et réessayer.",
  'terms.acceptError': "Échec de l'enregistrement de votre acceptation. Veuillez réessayer.",

  // Additional Common & Import Keys
  'common.previous': 'Précédent',
  'common.remove': 'Supprimer',
  'common.success': 'Enregistré avec succès',
  'common.failedToSave': "Échec de l'enregistrement",
  'import.useCurrentSetupDesc': 'Associer la configuration actuelle du kart aux sessions importées.',

  // Search & Filter Bar
  'search.booleanLogicUse': 'Combinez les termes avec',
  'search.booleanLogicOr': 'ou',
  'search.booleanLogicGroup': 'et groupez les expressions avec des parenthèses',
  'filter.operator.eq': 'est',
  'filter.operator.neq': 'n’est pas',
  'filter.operator.gt': 'supérieur à',
  'filter.operator.gte': 'au moins',
  'filter.operator.lt': 'inférieur à',
  'filter.operator.lte': 'au plus',
  'filter.operator.range': 'entre',
  'filter.operator.contains': 'contient',
  'filter.remove': 'Supprimer le filtre',
  'filter.done': 'Terminé',
  'filter.clearInput': 'Effacer la saisie',
  'filter.selectField': 'Filtrer par champ',
  'filter.pressEnter': 'Appuyez sur Entrée pour appliquer',
  'filter.selectValues': 'Sélectionner des valeurs',
  'filter.noMatchingOptions': 'Aucune option correspondante',

  // Search Schemas
  'filter.session.bareSearchExample': 'Rechercher par nom de piste',
  'filter.session.searchTrack': 'Filtrer par nom de piste',
  'filter.session.filterLaps': 'Filtrer par nombre total de tours',
  'filter.session.filterBestTime': 'Filtrer par meilleur temps au tour (secondes)',
  'filter.session.filterMaxSpeed': 'Filtrer par vitesse de pointe (km/h)',
  'filter.session.filterMaxRpm': 'Filtrer par régime moteur maximal',
  'filter.session.filterDate': 'Filtrer par date de session',
  'filter.session.filterShared': 'Filtrer par statut de partage d’équipe',
  'filter.session.filterVisibility': 'Filtrer par propriété ou visibilité d’équipe',
  'filter.session.visibilityMine': 'Mes sessions',
  'filter.session.visibilityShared': 'Partagées avec l’équipe',
  'filter.session.exampleTrackLaps': 'Sessions à Lonato avec 10+ tours',
  'filter.session.exampleBestSpeed': 'Tours rapides avec vitesse de pointe élevée',

  'filter.analysis.bareSearchExample': 'Rechercher par titre d’analyse ou nom de piste',
  'filter.analysis.searchTitle': 'Filtrer par titre d’analyse',
  'filter.analysis.searchTrack': 'Filtrer par nom de piste',
  'filter.analysis.filterType': 'Filtrer par type d’analyse',
  'filter.analysis.filterDate': 'Filtrer par date de création',
  'filter.analysis.filterShared': 'Filtrer par statut de partage d’équipe',
  'filter.analysis.filterVisibility': 'Filtrer par propriété ou partage d’équipe',
  'filter.analysis.exampleCornerTrack': 'Analyses de virages à Lonato',
  'filter.analysis.exampleSharedDate': 'Analyses partagées de 2026',

  'filter.trackRaces.bareSearchExample': 'Rechercher par titre d’événement, saison ou catégorie',
  'filter.trackRaces.searchTitle': 'Filtrer par titre d’événement',
  'filter.trackRaces.searchSeason': 'Filtrer par saison de championnat',
  'filter.trackRaces.searchCategory': 'Filtrer par catégorie de course',
  'filter.trackRaces.filterRound': 'Filtrer par numéro de manche',
  'filter.trackRaces.filterDate': 'Filtrer par date d’événement',
  'filter.trackRaces.exampleCatDate': 'Événements ROK Mini en 2026',
  'filter.trackRaces.exampleSeasonRound': 'Deux premières manches de la ROK Cup',

  'filter.tracks.bareSearchExample': 'Rechercher par nom de piste ou pays',
  'filter.tracks.searchName': 'Filtrer par nom de piste',
  'filter.tracks.searchCountry': 'Filtrer par code pays',
  'filter.tracks.filterType': 'Filtrer par source de piste (officielle ou mesurée)',
  'filter.tracks.filterSessions': 'Filtrer par nombre de sessions enregistrées',
  'filter.tracks.filterLaps': 'Filtrer par nombre de tours enregistrés',
  'filter.tracks.filterEvents': 'Filtrer par nombre d’événements officiels',
  'filter.tracks.filterDrivers': 'Filtrer par nombre de pilotes officiels',
  'filter.tracks.exampleItSessions': 'Pistes italiennes avec sessions enregistrées',
  'filter.tracks.exampleOfficialEvents': 'Circuits officiels avec 3+ événements',

  'filter.leaderboard.bareSearchExample': 'Rechercher par pilote, catégorie, saison ou événement',
  'filter.leaderboard.searchDriver': 'Filtrer par nom de pilote',
  'filter.leaderboard.searchCategory': 'Filtrer par catégorie de course',
  'filter.leaderboard.searchSeason': 'Filtrer par saison de championnat',
  'filter.leaderboard.searchEvent': 'Filtrer par nom d’événement',
  'filter.leaderboard.filterLapTime': 'Filtrer par temps au tour (secondes)',
  'filter.leaderboard.filterSpeed': 'Filtrer par vitesse de pointe (km/h)',
  'filter.leaderboard.filterRpm': 'Filtrer par régime moteur maximal',
  'filter.leaderboard.filterDate': 'Filtrer par date du tour',
  'filter.leaderboard.exampleTimeSpeed': 'Tours sous 48 s avec vitesse de pointe élevée',
  'filter.leaderboard.exampleCatTime': 'Tours catégorie Mini entre 52 s et 54 s',

  'filter.tyres.bareSearchExample': 'Rechercher par nom de train, marque, modèle ou code-barres',
  'filter.tyres.searchName': 'Filtrer par nom du train de pneus',
  'filter.tyres.searchBrand': 'Filtrer par marque de pneus',
  'filter.tyres.searchModel': 'Filtrer par gomme / modèle de pneus',
  'filter.tyres.searchSize': 'Filtrer par dimension de pneus',
  'filter.tyres.searchBarcode': 'Filtrer par code-barres scanné',
  'filter.tyres.filterStatus': 'Filtrer par statut du cycle de vie',
  'filter.tyres.filterCondition': 'Filtrer par état d’usure restant (%)',
  'filter.tyres.filterLaps': 'Filtrer par nombre total de tours parcourus',
  'filter.tyres.filterDistance': 'Filtrer par distance totale parcourue (km)',
  'filter.tyres.exampleActiveBrand': 'Trains de pneus LeCont actifs',
  'filter.tyres.exampleConditionLaps': 'Pneus avec >50 % de vie et <30 tours',

  'filter.teamMembers.bareSearchExample': 'Rechercher par nom ou e-mail du membre',
  'filter.teamMembers.searchName': 'Filtrer par nom du membre',
  'filter.teamMembers.searchEmail': 'Filtrer par e-mail du membre',
  'filter.teamMembers.filterRole': 'Filtrer par rôle dans l’équipe',
  'filter.teamMembers.exampleRoleAdmin': 'Administrateurs d’équipe',
  'filter.teamMembers.exampleNameRole': 'Membres ou éditeurs correspondant au nom',

  'filter.teamSharing.bareSearchExample': 'Rechercher par titre, propriétaire ou piste',
  'filter.teamSharing.searchTitle': 'Filtrer par titre de l’élément',
  'filter.teamSharing.searchOwner': 'Filtrer par nom du propriétaire',
  'filter.teamSharing.searchTrack': 'Filtrer par nom de piste',
  'filter.teamSharing.filterKind': 'Filtrer par type d’élément partagé',
  'filter.teamSharing.kindSession': 'Session',
  'filter.teamSharing.kindAnalysis': 'Analyse',
  'filter.teamSharing.filterAccess': 'Filtrer par droit d’accès',
  'filter.teamSharing.accessRead': 'Lecture seule',
  'filter.teamSharing.accessWrite': 'Lecture et écriture',
  'filter.teamSharing.exampleSessionTrack': 'Sessions partagées de Lonato',
  'filter.teamSharing.exampleAnalysisWrite': 'Analyses partagées modifiables',

  'filter.drivers.bareSearchExample': 'Rechercher par nom de pilote, équipe, catégorie ou matériel',
  'filter.drivers.searchName': 'Filtrer par nom de pilote',
  'filter.drivers.searchCountry': 'Filtrer par code de nationalité',
  'filter.drivers.searchTeam': 'Filtrer par équipe',
  'filter.drivers.searchCategory': 'Filtrer par catégorie',
  'filter.drivers.searchChassis': 'Filtrer par marque de châssis',
  'filter.drivers.searchEngine': 'Filtrer par marque de moteur',
  'filter.drivers.filterEntries': 'Filtrer par nombre d’engagements',
  'filter.drivers.exampleCountryEntries': 'Pilotes italiens avec 5+ engagements',
  'filter.drivers.exampleCatTeam': 'Pilotes Mini d’une équipe spécifique',

  'filter.driverHistory.bareSearchExample': 'Rechercher par saison, événement, piste ou catégorie',
  'filter.driverHistory.searchSeason': 'Filtrer par saison de championnat',
  'filter.driverHistory.searchEvent': 'Filtrer par nom d’événement',
  'filter.driverHistory.searchTrack': 'Filtrer par nom de circuit',
  'filter.driverHistory.searchCategory': 'Filtrer par catégorie',
  'filter.driverHistory.searchTeam': 'Filtrer par nom d’équipe',
  'filter.driverHistory.filterPos': 'Filtrer par position finale',
  'filter.driverHistory.filterGrid': 'Filtrer par position sur la grille',
  'filter.driverHistory.filterPoints': 'Filtrer par points marqués au championnat',
  'filter.driverHistory.filterBestLap': 'Filtrer par meilleur tour (secondes)',
  'filter.driverHistory.filterPenalties': 'Filtrer par nombre de pénalités',
  'filter.driverHistory.examplePodiums': 'Podiums (Top 3)',
  'filter.driverHistory.examplePointsPenalty': 'Événements à forts points sans pénalité',

  // Additional Analysis & Component Keys
  'braking.colSelect': 'Sél',
  'braking.colCompare': 'Cmp',
  'braking.scoreUnit': '/ 100',
  'braking.trackOverview': 'Aperçu de la piste',
  'braking.cornersCount': '{count} virages',
  'braking.trackAnalysis': 'Analyse de freinage sur la piste',
  'braking.lapsTotal': '{count} tours au total',
  'braking.sample': 'Échantillon',
  'lapdiff.pointDetail': 'Détail du point',
  'lapdiff.selectTwoLaps': 'Sélectionner 2 tours',
  'lapdiff.lapTime': 'Temps au tour',
  'aggregationdiff.toggleLayers': 'Afficher/masquer les calques',
  'aggregationdiff.leftInner': 'Gauche (Intérieur)',
  'aggregationdiff.rightOuter': 'Droite (Extérieur)',
  'aggregationdiff.selectLap': 'Sélectionner un tour',
  'aggregationdiff.modeSingleLap': 'Tour unique',
  'aggregationdiff.modeSessions': 'Sessions',
  'braking.phaseBraking': 'Freinage',
  'braking.phaseAccel': 'Accélération',
  'setup.tabFront': 'Avant',
  'setup.tabRear': 'Arrière',
  'team.you': 'Vous',
  'races.entries': 'Engagés',
  // Filter Schema & UI Translations
  'filter.filterBy': 'Filtrer par {label}',
  'filter.removeFilter': 'Supprimer le filtre {label}',
  'filter.prevMonth': 'Mois précédent',
  'filter.nextMonth': 'Mois suivant',
  'filter.selectStartDate': 'Sélectionner la date de début dans le calendrier',
  'filter.op.exact': 'Exact',
  'filter.op.atLeast': 'Au moins',
  'filter.op.atMost': 'Au plus',
  'filter.op.between': 'Entre',
  'filter.op.greater': 'Supérieur',
  'filter.op.less': 'Inférieur',
  'filter.preset.today': 'Aujourd’hui',
  'filter.preset.last7d': '7 derniers jours',
  'filter.preset.last30d': '30 derniers jours',
  'filter.preset.last90d': '90 derniers jours',
  'filter.preset.last1y': 'Dernière année',
  'filter.preset.last7dShort': '7 dern. j',
  'filter.preset.last30dShort': '30 dern. j',
  'filter.preset.last90dShort': '90 dern. j',
  'filter.preset.last1yShort': '1 dern. an',
  'filter.sessionType.race': 'Course',
  'filter.sessionType.final': 'Finale',
  'filter.sessionType.pre_final': 'Pré-finale',
  'filter.sessionType.heat': 'Manche',
  'filter.sessionType.qualifying': 'Qualifications',
  'filter.unit.laps': 'tours',
  'filter.schema.tyres.title': 'Syntaxe de recherche des pneus',
  'filter.schema.tyres.subtitle': 'Filtrer les pneus par marque, gomme, usure, code-barres, piste ou statut jeté.',
  'filter.field.brand': 'Marque',
  'filter.desc.brand': 'Fabricant de pneus (Mojo, Vega, LeCont, Bridgestone, etc.)',
  'filter.field.tyreModel': 'Modèle de pneu',
  'filter.placeholder.tyreModel': 'ex. D2, D5, W5, CIK Option',
  'filter.desc.tyreModel': 'Nom du modèle ou spécification de gomme',
  'filter.field.compound': 'Gomme',
  'filter.desc.compound': 'Catégorie de gomme (sec, pluie, slick)',
  'filter.compound.dry': 'Sec',
  'filter.compound.wet': 'Pluie',
  'filter.compound.slick': 'Slick',
  'filter.compound.rain': 'Pluie',
  'filter.field.setNumber': 'Numéro de train',
  'filter.desc.setNumber': 'Numéro de train de pneus attribué dans l’inventaire',
  'filter.field.totalLaps': 'Tours totaux',
  'filter.desc.totalLaps': 'Total cumulé des tours parcourus avec ce train de pneus',
  'filter.preset.tyreFresh': 'Neuf (0..15 tours)',
  'filter.preset.tyreBrokenIn': 'Rodé (16..50 tours)',
  'filter.preset.tyreHighMileage': 'Fort kilométrage (> 50 tours)',
  'filter.field.barcode': 'Code-barres',
  'filter.placeholder.barcode': 'Code-barres AVG, AVD, ARG, ARD',
  'filter.desc.barcode': 'Correspondance partielle sur un code-barres du train de pneus',
  'filter.field.lastTrack': 'Dernière piste',
  'filter.desc.lastTrack': 'Dernière piste où ce train de pneus a été utilisé',
  'filter.field.discarded': 'Jetés',
  'filter.desc.discarded': 'Indique si le train de pneus a été marqué comme jeté',
  'filter.discarded.false': 'Non',
  'filter.discarded.true': 'Oui',
  'filter.example.activeTyres': 'Trains de pneus actifs (non jetés)',
  'filter.example.dryMojo': 'Pneus secs Mojo',
  'filter.example.highMileage70': 'Trains de pneus à fort kilométrage de plus de 70 tours',
  'filter.example.freshTyres': 'Pneus neufs / faible kilométrage',
  'filter.example.lonatoTyres': 'Pneus utilisés à Lonato depuis août 2026',
  'filter.example.vegaOrWet': 'Trains Vega ou tous pneus pluie',
  'filter.field.date': 'Date',
  'filter.desc.date': 'Filtrer par période relative (-7d, -30d, today) ou plage de dates du calendrier',
  'filter.field.track': 'Piste',
  'filter.desc.track': 'Correspond au nom de la piste',
  'filter.placeholder.track': 'ex. Wohlen, Lonato',
  'filter.field.driver': 'Pilote',
  'filter.desc.driver': 'Correspond au nom du pilote',
  'filter.placeholder.driver': 'ex. Yanick',
  'filter.field.season': 'Saison',
  'filter.desc.season': 'Correspond à l’année de la saison',
  'filter.field.category': 'Catégorie',
  'filter.desc.category': 'Catégorie de course canonique',
  'filter.field.championship': 'Championnat',
  'filter.desc.championship': 'Nom du championnat',
  'filter.field.sessionType': 'Type de session',
  'filter.desc.sessionType': 'Classification de session (course, manche, qualifications, finale)',
  'filter.field.position': 'Position',
  'filter.field.finishPosition': 'Position finale',
  'filter.desc.position': 'Position d’arrivée (ex. position:<=3 pour les podiums)',
  'filter.preset.posWinner': 'Vainqueur (P1)',
  'filter.preset.posPodium': 'Podium (≤ P3)',
  'filter.preset.posTop5': 'Top 5 (≤ P5)',
  'filter.preset.posTop10': 'Top 10 (≤ P10)',
  'filter.field.temp': 'Température',
  'filter.desc.temp': 'Température ambiante de la session en Celsius (ex. temp:15..25)',
  'filter.preset.tempCool': 'Frais (< 15°C)',
  'filter.preset.tempMild': 'Doux (15..25°C)',
  'filter.preset.tempWarm': 'Chaud (≥ 25°C)',
  'filter.field.laps': 'Tours',
  'filter.desc.laps': 'Correspond au nombre de tours effectués (ex. laps:>=5, laps:5..20)',
  'filter.preset.lapsShort': 'Court (≤ 5 tours)',
  'filter.preset.lapsMedium': 'Moyen (6..15 tours)',
  'filter.preset.lapsLong': 'Long (> 15 tours)',
  'analysis.sector': 'Analyse par secteur',
  'analysis.corner': 'Vitesse en virage',
  'analysis.braking': 'Analyse du freinage',
  'analysis.lapdiff': 'Comparaison de tours',
  'analysis.aggregation': 'Agrégation',
  'analysis.aggregationdiff': 'Comparaison d’agrégation',
  'filter.schema.analyses.title': 'Syntaxe de recherche des analyses',
  'filter.schema.analyses.subtitle': 'Filtrer l’historique des analyses avec des clés structurées ou des mots-clés.',
  'filter.field.nameTrack': 'Nom / Piste',
  'filter.placeholder.nameTrack': 'ex. Sarno, Essai perso',
  'filter.desc.nameTrack': 'Correspond au nom de l’analyse ou de la piste (correspondance partielle)',
  'filter.field.toolType': 'Type d’outil',
  'filter.placeholder.toolType': 'ex. sector, corner, lapdiff, aggregation, aggregationdiff',
  'filter.desc.toolType': 'Filtrer par type d’outil d’analyse (sector, corner, lapdiff, aggregation, aggregationdiff)',
  'filter.example.sarnoSector': 'Analyses par secteur à Sarno',
  'filter.example.lapdiff30d': 'Comparaisons de tours des 30 derniers jours',
  'filter.example.wohlenCorner': 'Analyses de virages à Wohlen ou Mirecourt',
  'filter.schema.sessions.title': 'Syntaxe de recherche des sessions',
  'filter.schema.sessions.subtitle': 'Filtrer les sessions à l’aide de clés structurées ou de mots-clés.',
  'filter.field.trackDriver': 'Piste / Pilote',
  'filter.placeholder.trackDriver': 'ex. Wohlen, Mirecourt',
  'filter.desc.trackDriver': 'Correspond au nom de la piste ou du pilote (correspondance partielle)',
  'filter.schema.driverHistory.title': 'Syntaxe de recherche de l’historique pilote',
  'filter.schema.driverHistory.subtitle': 'Filtrer l’historique de carrière par piste, championnat, catégorie, type de session, position ou saison.',
  'filter.example.podiumWohlen': 'Podiums à Wohlen',
  'filter.example.dd2Races2026': 'Courses DD2 en 2026',
  'filter.example.victoriesLast1y': 'Victoires au cours de la dernière année',
  'filter.schema.driversList.title': 'Syntaxe de recherche des pilotes',
  'filter.schema.driversList.subtitle': 'Filtrer les pilotes par nom, saison active, catégorie ou date de participation.',
  'filter.field.driverName': 'Nom du pilote',
  'filter.placeholder.driverName': 'ex. Yanick, Senn',
  'filter.desc.driverName': 'Correspond au prénom ou au nom du pilote',
  'filter.example.findDriverYanick': 'Trouver les pilotes correspondant à Yanick',
  'filter.example.activeDd22026': 'Pilotes DD2 actifs en 2026',
  'filter.example.driversLast90d': 'Pilotes ayant couru au cours des 90 derniers jours',
  'filter.schema.teamMembers.title': 'Syntaxe de recherche des membres d’équipe',
  'filter.schema.teamMembers.subtitle': 'Filtrer les membres de l’équipe par nom, rôle ou e-mail.',
  'filter.field.memberName': 'Nom du membre',
  'filter.placeholder.memberName': 'ex. Yanick, Alice',
  'filter.desc.memberName': 'Correspond au nom d’affichage du membre',
  'filter.field.role': 'Rôle',
  'filter.desc.role': 'Niveau de permission (admin, gérer, lecture)',
  'team.role.admin': 'Admin',
  'filter.field.email': 'E-mail',
  'filter.placeholder.email': 'ex. gmail.com',
  'filter.desc.email': 'Correspond à l’adresse e-mail',
  'filter.example.findMemberYanick': 'Trouver les membres correspondant à Yanick',
  'filter.example.findTeamAdmins': 'Trouver les administrateurs de l’équipe',
  'filter.example.findTeamManage': 'Trouver les membres avec droits de gestion',
  'filter.schema.teamSharing.title': 'Syntaxe de recherche des partages d’équipe',
  'filter.schema.teamSharing.subtitle': 'Filtrer les accès partagés par propriétaire, type de partage ou niveau de permission.',
  'filter.field.ownerName': 'Propriétaire / Nom',
  'filter.desc.ownerName': 'Correspond au nom du propriétaire',
  'filter.field.shareScope': 'Portée du partage',
  'filter.desc.shareScope': 'Type de portée du partage (toutes les données, session unique, piste spécifique)',
  'filter.shareScope.all': 'Toute la télémétrie',
  'filter.shareScope.single': 'Session unique',
  'filter.shareScope.track': 'Piste spécifique',
  'filter.example.sharesYanick': 'Trouver les partages de Yanick',
  'filter.example.sharesAllRead': 'Partages complets de télémétrie en lecture seule',
  'filter.schema.trackLeaderboard.title': 'Syntaxe de recherche du classement de piste',
  'filter.schema.trackLeaderboard.subtitle': 'Filtrer les tours et sessions du classement par pilote, saison, catégorie, position ou température.',
  'filter.example.yanickFastest2026': 'Meilleurs tours de Yanick lors de la saison 2026',
  'filter.example.podiumSeniorMax': 'Podiums en Senior MAX',
  'filter.example.warm90d': 'Sessions par temps chaud au cours des 90 derniers jours',
  'filter.schema.trackRaceEvents.title': 'Syntaxe de recherche des événements de course',
  'filter.schema.trackRaceEvents.subtitle': 'Filtrer les événements de course par saison, championnat, catégorie ou pilote participant.',
  'filter.desc.driverEvent': 'Correspond à un pilote participant à l’événement',
  'filter.example.rmc2026': 'Événements RMC Switzerland 2026',
  'filter.example.yanick2025': 'Événements auxquels Yanick a participé en 2025',
  'filter.example.dd2Last1y': 'Événements DD2 au cours de la dernière année',
  'filter.schema.tracks.title': 'Syntaxe de recherche des pistes',
  'filter.schema.tracks.subtitle': 'Filtrer les pistes par nom ou mots-clés.',
  'filter.field.trackName': 'Nom de la piste',
  'filter.example.findWohlen': 'Trouver les pistes correspondant à Wohlen',
  'filter.example.exactTrack': 'Correspondance exacte du nom de la piste',
};
